import { C as isAgenticChatForbiddenError, D as _DefaultWorkflowGraph, T as isNoDuoNamespaceError, _ as _DefaultWorkflowToken, a as _BM25CodeSnippetsRank, c as USER_INTERRUPTED_COMMAND, d as isCommandError, f as isCommandTimedOut, g as WorkflowTokenService, h as _DefaultModelResolver, i as RgEmbeddedBinaryPath, l as WorkflowCommandService, m as ModelResolverService, n as ActionExecutorFactory, o as CodeSnippetRanker, p as WorkflowEventsChannel, r as RgBinaryProvider, t as DirectActionExecutor, u as commandTimedOutMessage, v as WorkflowRailsService, y as _DefaultWorkflowRails } from "./direct_action_executor-C20YagJV.mjs";
import { n as renderViolation, r as SandboxViolations } from "./public-CCJiLaMq.mjs";
import { ClientFeatureFlags, FeatureFlagService, FixedTimeCircuitBreaker, GID_NAMESPACE_GROUP, GID_NAMESPACE_PROJECT, GitLabApiService, MaxAttemptsCircuitBreaker, UserService, applyEol, createFallbackService, detectEol, doNotAwait, ensureEndsWithSlash, getLanguageServerVersion, ifVersionGte, toGitLabGid, truncateToByteLimit, tryParseGitLabGid } from "@gitlab-org/core";
import { Logger, withPrefix } from "@gitlab-org/logging";
import { Implements, Injectable, Service, ServiceLifetime, collection, createInterfaceId } from "@gitlab/needle";
import { DuoWorkflowStatus, GET_WORKFLOW_EVENTS_QUERY, ToolApprovalType, WorkflowDefinition, WorkflowExecutorError, WorkflowRunner, WorkflowStatusCode, WorkflowStatusCodeMessages, WorkflowSuccessCode, defaultFlowConfigSchema, generateErrorMessageFromStatusCode, generateGraphqlWorkflowId, getLatestEvent, isWorkflowExecutorErrorEvent, resolveWorkflowDefinition, tryParseFlowConfig } from "@gitlab-lsp/workflow-api";
import { DUO_WORKFLOW_EVENT, DuoWorkflowTracker } from "@gitlab-org/telemetry";
import { ConfigService, getDuoProxyMode } from "@gitlab-org/config";
import { FileAccessService, FileNotFoundError, FsClient, fileLookupKey, fsPathToUri, isBinaryFile, isFileSchemeUri, isVirtualWorkspaceUri, workspaceFolderPathFromUri } from "@gitlab-org/fs";
import { ErrorHandler, SanitizedError } from "@gitlab-org/errors";
import { CompositeDisposable } from "@gitlab-org/disposable";
import { InvalidInstanceVersionError, LsFetch, WebSocketFactory, WebSocketReadyState, getDroppedOptionsWarnings, toIsomorphicWsOptions } from "@gitlab-org/fetch";
import { RepositoryDiscoveryService, parseGitLabRemote } from "@gitlab-org/repositories";
import { MCP_TOOL_FAILURE_PREFIX, McpManagerWorkflowExecutorAdaptor, McpToolApprovalController, McpToolName, getTrustedReadableDirectories } from "@gitlab-org/ai-configuration";
import { persistPatternApprovalForSession, persistToolApprovalForSession } from "@gitlab-org/tool-approval";
import { SecretRedactor } from "@gitlab-org/secret-redaction";
import { DocumentQualityService, formatDiagnostic, formatRangeLocation, rangeOverlapsAny } from "@gitlab-org/document";
import { Action, approval_ApprovalSourceFromJSON } from "@gitlab-org/duo-workflow-service";
import { crc32 } from "node:zlib";
import { isAbsolute, join, normalize, relative, resolve, sep } from "node:path";
import { mkdir, readFile } from "node:fs/promises";
import { v4 } from "uuid";
import { EventEmitter } from "events";
import { calculateExponentialBackoff, delay } from "@gitlab-org/resiliency";
import { z } from "zod";
import { URI } from "vscode-uri";
import { BaseGitCommand, DefaultStatelessRepository, findGitRepoRoot, validateGitCommand } from "@gitlab-org/repositories/node";
import { execFile, spawn } from "node:child_process";
import { chmodSync, existsSync, mkdirSync, promises, readFileSync, renameSync, writeFileSync } from "node:fs";
import { promisify } from "node:util";
import { rgPath } from "@vscode/ripgrep";
import { tmpdir } from "node:os";
import { createHash } from "node:crypto";
import { expandHomeDir } from "@gitlab-org/fs/node";
//#region src/api/workflow_connection.ts
let _initClass$26;
function _applyDecs$26(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName$26(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName$26(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey$26(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS$26(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey$26(t) {
	var i = _toPrimitive$26(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$26(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName$26(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS$26(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
const WorkflowConnection = createInterfaceId("WorkflowConnection");
let _DefaultWorkflowConne;
(class {
	static {
		[_DefaultWorkflowConne, _initClass$26] = _applyDecs$26(this, [Injectable(WorkflowConnection, [GitLabApiService, Logger])], []).c;
	}
	#cable;
	#pollingIntervalRef;
	#prefixedLogger;
	#listeners = [];
	#api;
	#circuitBreaker;
	constructor(api, logger) {
		this.#api = api;
		this.#prefixedLogger = withPrefix(logger, "[Workflow Connection]");
		this.#circuitBreaker = new MaxAttemptsCircuitBreaker(new FixedTimeCircuitBreaker(1, 3e3), 3);
	}
	#stopPolling() {
		this.#prefixedLogger.info("Stopping polling");
		clearInterval(this.#pollingIntervalRef);
		this.#pollingIntervalRef = void 0;
	}
	async pollForUpdates(messageCallback, workflowId) {
		if (this.#pollingIntervalRef) this.#stopPolling();
		this.#pollingIntervalRef = setInterval(async () => {
			try {
				const response = await this.#api.fetchFromApi({
					type: "graphql",
					query: GET_WORKFLOW_EVENTS_QUERY,
					variables: { workflowId: generateGraphqlWorkflowId(workflowId) }
				});
				this.#prefixedLogger.info("Polling for updates");
				const latestEvent = getLatestEvent(response);
				if (latestEvent) messageCallback(latestEvent);
			} catch (e) {
				this.#prefixedLogger.error(JSON.stringify(e));
				this.#stopPolling();
				this.#prefixedLogger.warn("Failed to poll for updates");
			}
		}, 5e3);
	}
	async handleRetryConnection(messageCallback, workflowId) {
		this.#cable = void 0;
		this.#prefixedLogger.info("Attempting to reconnect...");
		try {
			await this.#connect(messageCallback, workflowId);
		} catch (e) {
			this.#prefixedLogger.error("Failed to connect to cable", e);
			this.#circuitBreaker.error();
		}
	}
	disconnectCable() {
		for (const listener of this.#listeners) listener.dispose();
		this.#listeners = [];
		if (this.#cable) {
			this.#cable.disconnect();
			this.#cable = void 0;
		}
		if (this.#pollingIntervalRef) this.#stopPolling();
		this.#circuitBreaker.success();
	}
	async #connect(messageCallback, workflowId) {
		try {
			const channel = new WorkflowEventsChannel({ workflowId: generateGraphqlWorkflowId(workflowId) });
			const currentCable = await this.#api.connectToCable();
			this.#cable = currentCable;
			channel.on("checkpoint", async (msg) => {
				await messageCallback(msg);
			});
			currentCable.subscribe(channel);
			this.#prefixedLogger.info("Connection successful.");
			return currentCable;
		} catch (e) {
			const errorMsg = e instanceof Error ? e.message : String(e);
			throw new Error(`Failed to connect to Action Cable: ${errorMsg}`);
		}
	}
	async subscribeToUpdates(messageCallback, updateWorkflowCallback, workflowId) {
		try {
			this.#circuitBreaker.onReachedMaxAttempts(async () => {
				this.#prefixedLogger.error("Failed to reconnect. Falling back to polling.");
				updateWorkflowCallback(workflowId);
				await this.pollForUpdates(messageCallback, workflowId);
			});
			this.#circuitBreaker.onClose(async () => {
				updateWorkflowCallback(workflowId);
				await this.handleRetryConnection(messageCallback, workflowId);
			});
			if (this.#cable) {
				this.#prefixedLogger.warn("A cable was already present. Disconnecting before subscribing again.");
				this.disconnectCable();
			}
			const currentCable = await this.#connect(messageCallback, workflowId);
			this.#circuitBreaker.success();
			this.#listeners.push({ dispose: currentCable.on("disconnect", async (event) => {
				this.#prefixedLogger.error(`Disconnected from Action Cable. Error: ${event?.message}`);
				this.#circuitBreaker.error();
			}) });
			this.#listeners.push({ dispose: currentCable.on("close", async (event) => {
				this.#prefixedLogger.error(`Action Cable closed. Error: ${event?.message}`);
				this.#circuitBreaker.error();
			}) });
		} catch (e) {
			const errorMsg = e instanceof Error ? e.message : String(e);
			this.#prefixedLogger.error(`Subscription to Action Cable failed with error ${errorMsg}`);
			this.#circuitBreaker.error();
		}
	}
	static {
		_initClass$26();
	}
});
//#endregion
//#region src/utils/event_queue.ts
/**
* Simple EventQueue that converts callback-based events to async iteration.
*/
var EventQueue = class {
	#events = [];
	#waiters = [];
	push(event) {
		if (this.#waiters.length > 0) this.#waiters.shift()(event);
		else this.#events.push(event);
	}
	async #next() {
		if (this.#events.length > 0) return this.#events.shift();
		return new Promise((resolve) => {
			this.#waiters.push(resolve);
		});
	}
	async *[Symbol.asyncIterator]() {
		while (true) {
			const event = await this.#next();
			if (typeof event === "object" && event !== null && "type" in event && event.type === "completion") {
				if (event.statusCode !== WorkflowSuccessCode) yield new WorkflowExecutorError(generateErrorMessageFromStatusCode(event.statusCode), event.statusCode);
				return;
			}
			yield event;
		}
	}
};
//#endregion
//#region src/executors/node/actions/file_state_tracker.ts
let _initClass$25;
function _applyDecs$25(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName$25(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName$25(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey$25(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS$25(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey$25(t) {
	var i = _toPrimitive$25(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$25(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName$25(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS$25(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
var DuoFileNotReadError = class extends Error {
	name = "DuoFileNotReadError";
	constructor(relativeFilePath) {
		super(`You must read the file "${relativeFilePath}" before modifying it.`);
	}
};
var DuoFileModifiedSinceLastReadError = class extends Error {
	name = "DuoFileModifiedSinceLastReadError";
	constructor(relativeFilePath) {
		super(`File "${relativeFilePath}" has been modified since it was last read. You must read the file again before modifying it.`);
	}
};
const FileStateTracker = createInterfaceId("FileStateTracker");
let _DefaultFileStateTrac;
(class {
	static {
		[_DefaultFileStateTrac, _initClass$25] = _applyDecs$25(this, [Service({
			dependencies: [Logger],
			lifetime: ServiceLifetime.Transient
		}), Implements(FileStateTracker)], []).c;
	}
	#fileContentHashes = /* @__PURE__ */ new Map();
	recordFileRead(fullFilePath, content) {
		const contentHash = this.#generateContentHash(content);
		this.#fileContentHashes.set(fullFilePath, contentHash);
	}
	assertFileNotModifiedSinceLastRead(workspaceFolderPath, filePath, currentContent) {
		const fullFilePath = join(workspaceFolderPath, filePath);
		const lastContentHash = this.#fileContentHashes.get(fullFilePath);
		if (lastContentHash === void 0) throw new DuoFileNotReadError(filePath);
		if (this.#generateContentHash(currentContent) !== lastContentHash) throw new DuoFileModifiedSinceLastReadError(filePath);
	}
	#generateContentHash(content) {
		return crc32(Buffer.from(content, "utf8")).toString(16);
	}
	static {
		_initClass$25();
	}
});
//#endregion
//#region src/executors/node/clients/constants.ts
const MAX_MESSAGE_SIZE = 4 * 1024 * 1024;
//#endregion
//#region src/executors/node/clients/errors.ts
var WebsocketStreamError = class extends Error {
	constructor(message, code, reason) {
		super(message);
		this.name = "WebsocketStreamError";
		this.code = code;
		this.reason = reason;
	}
};
function mapClientErrorToUserFacingStatusCode(error) {
	const errorMessage = error instanceof Error ? error.message : String(error);
	if (errorMessage.includes("USAGE_QUOTA_EXCEEDED")) return WorkflowStatusCode.USAGE_QUOTA_EXCEEDED;
	if (errorMessage.includes("unable to verify the first certificate")) return WorkflowStatusCode.MISSING_CERTIFICATE_SETTINGS;
	if (error instanceof WebsocketStreamError) switch (error.code) {
		case 4400: return WorkflowStatusCode.BAD_REQUEST;
		case 401:
		case 403:
		case 407: return WorkflowStatusCode.AUTH_TOKEN_ERROR;
		case 1003:
		case 1007: return WorkflowStatusCode.SERVICE_CONNECTION_UNSUPPORTED_DATA_TYPE;
		case 1006: return WorkflowStatusCode.SERVICE_CONNECTION_DROPPED;
		case 1008: return WorkflowStatusCode.USAGE_QUOTA_EXCEEDED;
		case 1009: return WorkflowStatusCode.SERVICE_CONNECTION_CLOSED_MESSAGE_TOO_BIG;
		case 1011: return WorkflowStatusCode.SERVICE_CONNECTION_INTERNAL_ERROR;
		case 1013: return WorkflowStatusCode.LOCKED_SOCKET;
		case 1014: return WorkflowStatusCode.SERVICE_CONNECTION_BAD_GATEWAY;
		case 1015: return WorkflowStatusCode.SERVICE_CONNECTION_TLS_HANDSHAKE;
	}
	return WorkflowStatusCode.GENERAL_FAILURE;
}
//#endregion
//#region src/executors/node/clients/websocket_workflow_stream.ts
const KEEPALIVE_PING_INTERVAL_MS = 45 * 1e3;
var WebSocketWorkflowStream = class extends EventEmitter {
	#socket;
	#logger;
	#instanceInfo;
	#keepalivePingIntervalId;
	constructor(socket, logger, instanceInfo) {
		super();
		this.#socket = socket;
		this.#logger = logger;
		this.#instanceInfo = instanceInfo;
		this.#setupEventHandlers();
	}
	#setupEventHandlers() {
		this.#socket.on("message", (event) => {
			try {
				const data = event && typeof event === "object" && "data" in event ? event.data : event;
				let message;
				if (typeof data === "string") message = data;
				else if (Buffer.isBuffer(data)) message = data.toString("utf8");
				else if (data instanceof ArrayBuffer) message = Buffer.from(data).toString("utf8");
				else if (Array.isArray(data)) message = Buffer.concat(data).toString("utf8");
				else {
					this.#logger.warn("Received unknown message format");
					return;
				}
				if (!message || message === "undefined") {
					this.#logger.warn("Received empty or undefined message, skipping");
					return;
				}
				const parsedEvent = Action.fromJSON(JSON.parse(message));
				this.emit("data", parsedEvent);
			} catch (err) {
				this.#logger.error(`Failed to parse WebSocket message`, {
					event,
					error: err
				});
				this.#emitError(err instanceof Error ? err : new Error(String(err)));
			}
		});
		this.#socket.on("open", () => {
			this.#logger.debug("WebSocket connection opened");
			this.emit("open");
		});
		this.#socket.on("error", (event) => {
			this.#logger.error("WebSocket error:", event);
			this.#emitError(event instanceof Error ? event : new Error(String(event)));
		});
		this.#socket.on("unexpected-response", (_request, response) => {
			const statusCode = response?.statusCode;
			const statusMessage = response?.statusMessage;
			this.#logger.error(`WebSocket upgrade rejected with HTTP ${statusCode ?? "unknown"} ${statusMessage ?? ""}`.trim());
			response?.resume?.();
			this.#emitError(new WebsocketStreamError(`WebSocket upgrade failed with HTTP status ${statusCode ?? "unknown"}`, statusCode, statusMessage));
		});
		this.#socket.on("close", (code, reason) => {
			clearInterval(this.#keepalivePingIntervalId);
			const reasonString = reason?.toString("utf8");
			this.#logger.debug(`WebSocket connection closed: ${JSON.stringify({
				code,
				reason: reasonString
			})}`);
			if (code === 1e3) {
				this.emit("end");
				return;
			}
			if (code === 1006) {
				let shouldSuppressAbnormalClosure = true;
				ifVersionGte(this.#instanceInfo?.instanceVersion, "18.5.0", () => {
					shouldSuppressAbnormalClosure = false;
				}, () => {
					shouldSuppressAbnormalClosure = true;
				});
				if (shouldSuppressAbnormalClosure) {
					this.emit("end");
					return;
				}
			}
			const error = new WebsocketStreamError("WebSocket closed abnormally.", code, reasonString);
			this.#emitError(error);
		});
		this.#socket.on("pong", (data) => {
			let rtt = "unknown";
			try {
				const pingTime = parseInt(data.toString(), 10);
				rtt = `${Date.now() - pingTime}ms`;
			} catch (err) {
				this.#logger.debug("Failed to parse keepalive `pong` response", err);
			}
			this.#logger.debug(`WebSocket keepalive ping acknowledged. Round trip time: ${rtt}`);
		});
		this.#startKeepalivePingInterval();
	}
	/**
	* Emit an `error` event without ever crashing the process.
	*
	* Node's EventEmitter throws synchronously when an `'error'` event is emitted
	* while no listeners are registered. During a failed (re)connection the
	* underlying socket can emit a late abnormal `close` (1006) *after* the
	* connection promise has already rejected and removed its one-shot `error`
	* listener (see WebSocketWorkflowClient#executeWorkflow), leaving this stream
	* with no listeners. Without this guard that orphaned error surfaces as an
	* `uncaughtException`, which the CLI turns into a full shutdown — aborting the
	* retry loop mid-backoff. If nobody is listening, log it instead of throwing.
	*/
	#emitError(error) {
		if (this.listenerCount("error") === 0) {
			this.#logger.warn(`Unobserved WebSocket stream error: ${error.message}`);
			return;
		}
		this.emit("error", error);
	}
	#startKeepalivePingInterval() {
		this.#logger.debug(`Starting keepalive ping on websocket every ${KEEPALIVE_PING_INTERVAL_MS / 1e3}s`);
		this.#keepalivePingIntervalId = setInterval(() => {
			if (this.#socket.readyState !== WebSocketReadyState.OPEN) {
				this.#logger.warn(`Skipped sending keepalive ping because socket readystate is not OPEN. readystate is: "${this.#socket.readyState}"`);
				return;
			}
			const timestamp = Date.now().toString();
			this.#socket.ping(Buffer.from(timestamp), void 0, (err) => {
				if (err) this.#logger.error("Keepalive ping failed:", err);
			});
		}, KEEPALIVE_PING_INTERVAL_MS);
	}
	write(data) {
		if (this.#socket.readyState !== WebSocketReadyState.OPEN) {
			this.#logger.error(`Attempting to write to stream when socket is not open. Socket is in state: "${this.#socket.readyState}"`);
			return false;
		}
		this.#socket.send(JSON.stringify(data));
		return true;
	}
	end() {
		this.#socket.close(1e3);
	}
};
//#endregion
//#region src/executors/node/clients/websocket_client.ts
const CONNECTION_TIMEOUT_MS = 15e3;
var WebSocketWorkflowClient = class {
	#logger;
	#connectionDetails;
	#instanceInfo;
	#socket = null;
	#webSocketFactory;
	#stream = null;
	#socketClientOptions;
	#correlationId;
	#url;
	#agentPlatformFeatureSettingName;
	#langsmithTrace;
	#telemetry;
	#heartbeatInterval;
	#heartbeatIntervalMs = 60 * 1e3;
	constructor(logger, webSocketFactory, sslConfig, connectionDetails, workflowMetadata, instanceInfo, telemetry, agentPlatformFeatureSettingName, workflowOptions, langsmithTrace) {
		this.#logger = withPrefix(logger, "[WebSocketWorkflowClient]");
		this.#webSocketFactory = webSocketFactory;
		this.#connectionDetails = connectionDetails;
		this.#instanceInfo = instanceInfo;
		this.#telemetry = telemetry;
		this.#agentPlatformFeatureSettingName = agentPlatformFeatureSettingName;
		this.#langsmithTrace = langsmithTrace;
		if (langsmithTrace) this.#logger.debug(`Adding langsmith-trace header: ${langsmithTrace}`);
		this.#correlationId = v4();
		this.#socketClientOptions = this.#createConnectionMetadata(this.#correlationId, sslConfig, workflowMetadata);
		this.#url = this.#buildWebSocketUrl(connectionDetails, workflowMetadata, workflowOptions);
	}
	async disposeAsync() {
		this.#stopHeartbeat();
		if (this.#socket) {
			if (this.#socket.readyState === WebSocketReadyState.OPEN) this.#socket.close(1e3);
			else if (this.#socket.readyState === WebSocketReadyState.CONNECTING) {
				this.#logger.debug("WebSocket still connecting — terminating");
				this.#socket.terminate();
			}
			this.#socket = null;
		}
		if (this.#stream) this.#stream = null;
	}
	getResponseByteSize(clientEvent) {
		return Buffer.byteLength(JSON.stringify(clientEvent), "utf8");
	}
	getCorrelationId() {
		return this.#correlationId;
	}
	async executeWorkflow() {
		const url = this.#url;
		this.#logger.debug(`Connecting to: ${url}`);
		const clientOptions = await this.#socketClientOptions;
		const WebSocketImplementation = this.#webSocketFactory.implementation;
		this.#socket = new WebSocketImplementation(url, clientOptions);
		this.#stream = new WebSocketWorkflowStream(this.#socket, this.#logger, this.#instanceInfo);
		await new Promise((resolve, reject) => {
			if (!this.#stream) {
				reject(/* @__PURE__ */ new Error("Unexpected error - websocketWorkflowStream was somehow null. This should be impossible because we just created the stream."));
				return;
			}
			const timeoutId = setTimeout(() => {
				this.#logger.error(`WebSocket connection timeout after ${CONNECTION_TIMEOUT_MS}ms`);
				if (this.#stream) {
					this.#stream.removeListener("open", onOpen);
					this.#stream.removeListener("error", onError);
				}
				reject(WorkflowStatusCode.SERVICE_CONNECTION_FAILED);
			}, CONNECTION_TIMEOUT_MS);
			const onOpen = () => {
				clearTimeout(timeoutId);
				if (this.#stream) {
					this.#stream.removeListener("error", onError);
					resolve();
				}
			};
			const onError = (error) => {
				clearTimeout(timeoutId);
				this.#logger.error("WebSocket connection failed", error);
				if (this.#stream) this.#stream.removeListener("open", onOpen);
				const mappedStatusCode = mapClientErrorToUserFacingStatusCode(error);
				reject(mappedStatusCode === WorkflowStatusCode.GENERAL_FAILURE ? WorkflowStatusCode.SERVICE_CONNECTION_FAILED : mappedStatusCode);
			};
			this.#stream.once("open", onOpen);
			this.#stream.once("error", onError);
		});
		if (this.#stream) this.#startHeartbeat(this.#stream);
		return this.#stream;
	}
	#startHeartbeat(stream) {
		stream.on("error", () => this.#stopHeartbeat());
		stream.on("end", () => this.#stopHeartbeat());
		this.#heartbeatInterval = setInterval(() => {
			this.#sendHeartbeat();
		}, this.#heartbeatIntervalMs);
		this.#logger.debug(`Heartbeat started with ${Math.floor(this.#heartbeatIntervalMs / 1e3)}s interval`);
	}
	#sendHeartbeat() {
		if (!this.#stream) return;
		const heartbeatEvent = { heartbeat: { timestamp: Date.now() } };
		try {
			if (!this.#stream.write(heartbeatEvent)) this.#logger.warn("Heartbeat write returned \"false\" - this could indicate stream backpressure, network congestion, slow server processing, or a closed stream.");
			else this.#logger.debug(`Heartbeat sent: ${heartbeatEvent.heartbeat?.timestamp}`);
		} catch (error) {
			this.#logger.error("Failed to send heartbeat", error);
		}
	}
	#stopHeartbeat() {
		if (this.#heartbeatInterval) {
			clearInterval(this.#heartbeatInterval);
			this.#heartbeatInterval = void 0;
			this.#logger.debug("Heartbeat stopped");
		}
	}
	#isSecure() {
		return this.#connectionDetails.gitlabInstanceUrl.protocol === "https:";
	}
	#buildWebSocketUrl(connectionDetails, workflowMetadata, workflowOptions) {
		const baseUrl = new URL(ensureEndsWithSlash(connectionDetails.gitlabInstanceUrl));
		const url = new URL("./api/v4/ai/duo_workflows/ws", baseUrl);
		url.protocol = this.#isSecure() ? "wss:" : "ws:";
		url.searchParams.set("environment", "ide");
		if (workflowMetadata.projectId) url.searchParams.set("project_id", workflowMetadata.projectId.toString());
		if (workflowMetadata.namespaceId) url.searchParams.set("namespace_id", workflowMetadata.namespaceId.toString());
		if (workflowMetadata.rootNamespaceId) url.searchParams.set("root_namespace_id", workflowMetadata.rootNamespaceId.toString());
		if (workflowMetadata.selectedModelIdentifier) url.searchParams.set("user_selected_model_identifier", workflowMetadata.selectedModelIdentifier);
		if (workflowOptions?.workflowDefinition) url.searchParams.set("workflow_definition", workflowOptions.workflowDefinition);
		if (workflowOptions?.aiCatalogItemVersionId) url.searchParams.set("ai_catalog_item_version_id", String(workflowOptions.aiCatalogItemVersionId));
		return url.toString();
	}
	async #getSslOptions(sslConfig) {
		const { httpAgentOptions, ignoreCertificateErrors } = sslConfig;
		const certFiles = await this.#loadCertificateFiles(httpAgentOptions);
		return {
			...ignoreCertificateErrors ? { rejectUnauthorized: false } : {},
			...certFiles.ca ? { ca: certFiles.ca } : {},
			...certFiles.cert ? { cert: certFiles.cert } : {},
			...certFiles.certKey ? { key: certFiles.certKey } : {}
		};
	}
	#getUserAgent() {
		return `${(this.#telemetry?.ide?.name ?? "unknown").replace(/\s+/g, "-").toLowerCase()}/${this.#telemetry?.ide?.version ?? "unknown"} ${(this.#telemetry?.extension?.name ?? "unknown").replace(/\s+/g, "-").toLowerCase()}/${this.#telemetry?.extension?.version ?? "unknown"} gitlab-language-server/${getLanguageServerVersion() ?? "unknown"}`;
	}
	async #loadCertificateFiles(httpAgentOptions) {
		const { ca, cert, certKey } = httpAgentOptions || {};
		const result = {};
		try {
			if (ca) result.ca = await readFile(ca);
			if (cert) result.cert = await readFile(cert);
			if (certKey) result.certKey = await readFile(certKey);
		} catch (error) {
			this.#logger.error("Failed to load custom certificates", error);
		}
		return result;
	}
	async #createConnectionMetadata(correlationId, sslConfig, workflowMetadata) {
		const headers = {
			authorization: `Bearer ${this.#connectionDetails.token}`,
			"x-request-id": correlationId,
			"x-gitlab-language-server-version": getLanguageServerVersion(),
			"user-agent": this.#getUserAgent(),
			origin: this.#connectionDetails.gitlabInstanceUrl.origin
		};
		if (workflowMetadata.projectId) headers["x-gitlab-project-id"] = workflowMetadata.projectId.toString();
		if (workflowMetadata.namespaceId) headers["x-gitlab-namespace-id"] = workflowMetadata.namespaceId.toString();
		if (workflowMetadata.rootNamespaceId) headers["x-gitlab-root-namespace-id"] = workflowMetadata.rootNamespaceId.toString();
		if (this.#agentPlatformFeatureSettingName) headers["x-gitlab-agent-platform-feature-setting-name"] = this.#agentPlatformFeatureSettingName;
		if (this.#telemetry?.ide) {
			headers["x-gitlab-client-name"] = this.#telemetry.ide.name;
			headers["x-gitlab-client-version"] = this.#telemetry.ide.version;
		}
		if (this.#telemetry?.trackingContext) headers["x-gitlab-tracking-context"] = this.#telemetry.trackingContext;
		headers["x-gitlab-client-type"] = "node-websocket";
		if (this.#langsmithTrace) headers["langsmith-trace"] = this.#langsmithTrace;
		const connectionMetadata = { headers };
		const { proxyUrl, tls, agent } = this.#connectionDetails;
		for (const warning of getDroppedOptionsWarnings({
			proxyUrl,
			tls,
			agent
		})) this.#logger.warn(warning);
		const transportOptions = {
			...this.#isSecure() ? await this.#getSslOptions(sslConfig) : {},
			...toIsomorphicWsOptions({
				proxyUrl,
				tls,
				agent
			})
		};
		if (Object.keys(transportOptions).length > 0) {
			this.#logger.debug(`Applying WebSocket transport options: ${Object.keys(transportOptions).join(", ")}`);
			Object.assign(connectionMetadata, transportOptions);
		}
		return connectionMetadata;
	}
};
//#endregion
//#region src/executors/node/resolve_status_code.ts
/**
* Resolve a thrown/rejected value to a {@link WorkflowStatusCode}.
*
* @param fallback - resolves an unrecognised error; defaults to
*   `GENERAL_FAILURE`. Callers with richer context (e.g. websocket client
*   errors) can pass `mapClientErrorToUserFacingStatusCode`.
*/
function resolveWorkflowStatusCode(error, fallback = () => WorkflowStatusCode.GENERAL_FAILURE) {
	if (error instanceof WorkflowExecutorError) return error.statusCode;
	if (typeof error === "number") return error;
	return fallback(error);
}
//#endregion
//#region src/executors/node/utils/response_truncation.ts
function isPlaintextResponse(response) {
	return Object.hasOwn(response, "response");
}
function isScheduleNotificationResponse(response) {
	return Object.hasOwn(response, "accepted");
}
function createTruncatedPlainTextResponse(response, requestID) {
	return { actionResponse: {
		requestID,
		plainTextResponse: {
			response: response.response ? truncateToByteLimit(response.response, 1024, { suffix: "[Large response truncated...]" }) : "",
			error: ""
		}
	} };
}
function createTruncatedPlainTextErrorResponse(result, requestID, errorMessage) {
	const truncatedResponse = result.response ? truncateToByteLimit(result.response, 1024, { suffix: "[Large response truncated...]" }) : "";
	let finalErrorMessage = errorMessage;
	if (result.error) finalErrorMessage += `\nOriginal result container error:\n${truncateToByteLimit(result.error, 1024, { suffix: "[Large error truncated...]" })}`;
	return { actionResponse: {
		requestID,
		plainTextResponse: {
			response: truncatedResponse,
			error: finalErrorMessage
		}
	} };
}
function createTruncatedHttpErrorResponse(result, requestID, errorMessage) {
	let finalErrorMessage = errorMessage;
	if (result.error) finalErrorMessage += `\nOriginal result container error:\n${truncateToByteLimit(result.error, 1024, { suffix: "[Large error truncated...]" })}`;
	const truncatedBody = result.body ? truncateToByteLimit(result.body, 1024, { suffix: "[Large response body truncated...]" }) : "";
	return { actionResponse: {
		requestID,
		httpResponse: {
			headers: result.headers,
			statusCode: result.statusCode,
			body: truncatedBody,
			error: finalErrorMessage
		}
	} };
}
/**
* Creates a truncated response when size limit is exceeded.
* PlainTextResponse: no error field (truncation indicated in suffix only)
* HttpResponse: includes error field explaining the size limit
*/
function createSizeLimitExceededResponse(response, requestID, responseSize, maxSize) {
	if (isPlaintextResponse(response)) return createTruncatedPlainTextResponse(response, requestID);
	return createTruncatedHttpErrorResponse(response, requestID, `Maximum allowed size exceeded. Result: ${responseSize} bytes. Maximum allowed: ${maxSize} bytes`);
}
/**
* Creates a truncated response when serialization fails.
* Both response types include error field explaining the serialization failure.
*/
function createSerializationErrorResponse(response, requestID) {
	const errorMessage = "Failed to validate response size due to serialization error";
	if (isPlaintextResponse(response)) return createTruncatedPlainTextErrorResponse(response, requestID, errorMessage);
	return createTruncatedHttpErrorResponse(response, requestID, errorMessage);
}
//#endregion
//#region src/executors/node/node_executor.ts
let _initClass$24;
function _applyDecs$24(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName$24(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName$24(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey$24(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS$24(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey$24(t) {
	var i = _toPrimitive$24(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$24(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName$24(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS$24(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
const CLIENT_CAPABILITIES = [
	"shell_command",
	"read_file_chunked",
	"tool_call_approval",
	"tool_call_pattern_approval",
	"command_timeout",
	"web_search",
	"incremental_streaming",
	"tool_call_streaming"
];
const SCHEDULE_NOTIFICATION_CAPABILITY = "schedule_notification";
/**
* Merges an incremental ui_chat_log slice into the accumulated full log.
*
* With `incremental_streaming` enabled, DWS sends only the subset of ui_chat_log
* entries that changed since the last checkpoint. The slice starts from the last
* message that was in progress (which may have been partially streamed) and
* continues with any newly added messages.
*
* Merge strategy:
* - If the incoming slice is empty, return the accumulated log unchanged.
* - Find the position of the first incoming message in the accumulated log by
*   matching its `message_id`. If found, replace entries from that position
*   onward with the incoming slice (updating the in-progress message and
*   appending any new ones).
* - If the first message_id is not found (e.g. first checkpoint, or reset),
*   append the full incoming slice to the accumulated log.
*/
/**
* Minimal structural contract this merger depends on. The full chat-log entry
* shape is owned by `lib_workflow_api/ui_chat_log.ts` (BaseMessageSchema);
* here we only read `message_id` and otherwise pass entries through opaquely.
*/
function mergeIncrementalChatLog(accumulated, incoming) {
	if (incoming.length === 0) return [...accumulated];
	const firstMessageId = incoming[0]?.message_id;
	if (typeof firstMessageId === "string" && firstMessageId.length > 0) {
		const overlapIndex = accumulated.findIndex((entry) => entry?.message_id === firstMessageId);
		if (overlapIndex !== -1) return [...accumulated.slice(0, overlapIndex), ...incoming];
	}
	return [...accumulated, ...incoming];
}
const NodeExecutor = createInterfaceId("NodeExecutor");
const LOGGER_PREFIX = "[DuoWorkflowNodeExecutor]";
let _DefaultNodeExecutor;
(class {
	static {
		[_DefaultNodeExecutor, _initClass$24] = _applyDecs$24(this, [Service({
			dependencies: [
				ConfigService,
				DuoWorkflowTracker,
				ErrorHandler,
				FileStateTracker,
				GitLabApiService,
				Logger,
				LsFetch,
				McpManagerWorkflowExecutorAdaptor,
				McpToolApprovalController,
				ModelResolverService,
				RepositoryDiscoveryService,
				SecretRedactor,
				WorkflowTokenService,
				ActionExecutorFactory,
				WebSocketFactory
			],
			lifetime: ServiceLifetime.Transient
		}), Implements(NodeExecutor)], []).c;
	}
	#disposables = new CompositeDisposable();
	#currentWorkflowStatus;
	#duoWorkflowTracker;
	#webSocketFactory;
	#errorHandler;
	#fileStateTracker;
	#gitlabApiService;
	#prefixedLogger;
	#logger;
	#modelResolverService;
	#workflowTokenService;
	#repositoryDiscoveryService;
	#actionExecutor;
	#client = null;
	#stream = null;
	#sslConfig = {};
	#mcpManager;
	#mcpToolApprovalController;
	#socketConnectionDetails;
	#secretRedactor;
	#actionHandlerAbortController = null;
	#isRunningCommand = false;
	#telemetry;
	/**
	* Accumulated ui_chat_log for the current workflow run.
	* When incremental_streaming is active, DWS sends only the new/updated
	* messages per checkpoint. We merge them here so downstream consumers
	* always receive the full log.
	*/
	#accumulatedChatLog = [];
	constructor(configService, duoWorkflowTracker, errorHandler, fileStateTracker, gitlabApiService, logger, lsFetch, mcpManager, mcpToolApprovalController, modelResolverService, repositoryService, secretRedactor, workflowTokenService, actionExecutorFactory, webSocketFactory) {
		this.#webSocketFactory = webSocketFactory;
		this.#duoWorkflowTracker = duoWorkflowTracker;
		this.#errorHandler = errorHandler;
		this.#fileStateTracker = fileStateTracker;
		this.#gitlabApiService = gitlabApiService;
		this.#logger = logger;
		this.#prefixedLogger = withPrefix(logger, `${LOGGER_PREFIX}`);
		this.#modelResolverService = modelResolverService;
		this.#workflowTokenService = workflowTokenService;
		this.#repositoryDiscoveryService = repositoryService;
		this.#mcpManager = mcpManager;
		this.#mcpToolApprovalController = mcpToolApprovalController;
		this.#actionExecutor = actionExecutorFactory.createExecutor();
		this.#disposables.add(this.#actionExecutor);
		this.#secretRedactor = secretRedactor;
		this.#setSocketConnectionDetails(gitlabApiService, lsFetch, configService);
		this.#disposables.add(configService.onConfigChange((config) => {
			this.#setSslConfig(config);
			this.#setTelemetry(config);
			this.#updateSocketConnectionDetails(gitlabApiService, lsFetch, config);
		}));
		this.#setSslConfig(configService.get());
		this.#setTelemetry(configService.get());
	}
	#setSocketConnectionDetails(gitlabApiService, lsFetch, configService) {
		this.#updateSocketConnectionDetails(gitlabApiService, lsFetch, configService.get());
		this.#disposables.add(gitlabApiService.onApiReconfigured((data) => {
			if (data.isInValidState) this.#socketConnectionDetails = this.#buildSocketConnectionDetails(data.instanceInfo.instanceUrl, data.tokenInfo.token, lsFetch, configService.get());
			else this.#socketConnectionDetails = void 0;
		}));
	}
	#updateSocketConnectionDetails(gitlabApiService, lsFetch, config) {
		if (gitlabApiService.instanceInfo && gitlabApiService.tokenInfo) {
			const gitlabInstanceUrl = gitlabApiService.instanceInfo.instanceUrl;
			this.#socketConnectionDetails = this.#buildSocketConnectionDetails(gitlabInstanceUrl, gitlabApiService.tokenInfo.token, lsFetch, config);
		} else this.#socketConnectionDetails = void 0;
	}
	#buildSocketConnectionDetails(gitlabInstanceUrl, token, lsFetch, config) {
		return {
			gitlabInstanceUrl,
			token,
			...lsFetch.getWebSocketOptions(gitlabInstanceUrl, ...this.#getLsFetchOptionsArgs(config))
		};
	}
	#getLsFetchOptions(config) {
		const proxyResolutionMode = getDuoProxyMode(config.duo);
		return proxyResolutionMode === "direct" ? { proxyResolutionMode } : void 0;
	}
	#getLsFetchOptionsArgs(config) {
		const fetchOptions = this.#getLsFetchOptions(config);
		return fetchOptions ? [fetchOptions] : [];
	}
	#setSslConfig({ httpAgentOptions, ignoreCertificateErrors }) {
		this.#sslConfig = {
			httpAgentOptions,
			ignoreCertificateErrors
		};
	}
	#setTelemetry({ telemetry }) {
		this.#telemetry = telemetry;
	}
	/** Aborts the current action handler AbortController and replaces it with a fresh one. */
	#resetActionHandlerAbortController(reason) {
		this.#actionHandlerAbortController?.abort(reason);
		this.#actionHandlerAbortController = new AbortController();
	}
	async #forceDisconnect() {
		this.#prefixedLogger.info("Force disconnecting - aborting any outstanding action handlers, ending stream");
		this.#resetActionHandlerAbortController();
		await this.#client?.disposeAsync();
		this.#prefixedLogger.info("Force disconnected");
	}
	async disposeAsync() {
		this.#prefixedLogger.info("Disposing executor - starting shutdown");
		await this.#forceDisconnect();
		this.#disposables.dispose();
	}
	stopWorkflow() {
		this.#logger.debug("Requesting graceful workflow stop");
		this.#stream?.write({ stopWorkflow: { reason: "USER_ACTION_TRIGGERED_STOP" } });
	}
	interruptRunningCommand() {
		this.#logger.debug("Interrupting currently running command");
		this.#resetActionHandlerAbortController(new Error(USER_INTERRUPTED_COMMAND));
	}
	isCommandRunning() {
		return this.#isRunningCommand;
	}
	/**
	* Executes a workflow and yields events as they occur during execution.
	*
	* @param options - Configuration for the workflow execution
	* @yields {DuoWorkflowEvent | WorkflowExecutorError} - Stream of workflow events during execution
	* @returns {AsyncGenerator<DuoWorkflowEvent | WorkflowExecutorError, void, unknown>} - Generator that yields events until completion
	*
	* @remarks
	* In failure scenarios, the final yielded event will be a WorkflowExecutorError containing
	* the error details, including the WorkflowStatus code.
	* The generator completes (returns) when the workflow finishes successfully or encounters
	* a terminal error.
	*/
	async *runWorkflow(options) {
		const { workflowId, goal, workspaceFolderPath, workspaceFolderUri, toolApproval, workflowDefinition: rawWorkflowDefinition, aiCatalogItemVersionId, flowConfig, flowConfigSchemaVersion, flowConfigId, flowVersion, streaming, supportsScheduledWakes } = options;
		const workflowDefinition = resolveWorkflowDefinition(rawWorkflowDefinition);
		this.#prefixedLogger = withPrefix(this.#logger, `${LOGGER_PREFIX}[${workflowId}]`);
		this.#accumulatedChatLog = [];
		const eventQueue = new EventQueue();
		let workflowToken = null;
		try {
			this.#actionHandlerAbortController = new AbortController();
			this.#prefixedLogger.debug(`Running workflow: ${this.#secretRedactor.redactSecrets(JSON.stringify(options, null, 4), "workflow-run-options")}`);
			workflowToken = await this.#getAuthToken(workflowId, workflowDefinition, options.metadata.rootNamespaceId, options.metadata.projectPath);
			const workflowMetadata = await this.#workflowMetadata(workspaceFolderPath);
			const namespaceId = options.metadata.rootNamespaceId || options.metadata.namespaceId;
			const resolvedModel = await this.#modelResolverService.resolveModel(options.metadata.selectedModelIdentifier, namespaceId);
			if (options.langsmithTrace) this.#prefixedLogger.info(`LangSmith distributed tracing enabled, trace header: ${options.langsmithTrace}`);
			this.#client = this.#createWorkflowClient(options.metadata, resolvedModel, options.agentPlatformFeatureSettingName, options.langsmithTrace, {
				workflowDefinition,
				aiCatalogItemVersionId: aiCatalogItemVersionId ? tryParseGitLabGid(aiCatalogItemVersionId) : void 0
			});
			this.#prefixedLogger.debug("Creating websocket connection...");
			this.#stream = await this.#client.executeWorkflow();
			this.#prefixedLogger.debug("WebSocket connection created successfully");
			this.#stream.on("data", async (action) => {
				try {
					workflowToken = await this.#getAuthToken(workflowId, workflowDefinition, options.metadata.rootNamespaceId, options.metadata.projectPath);
					if (action.newCheckpoint) {
						const event = await this.#handleWorkflowCheckpoint(workflowId, action);
						if (event) eventQueue.push(event);
					} else {
						const abortSignal = this.#actionHandlerAbortController?.signal ?? new AbortController().signal;
						this.#isRunningCommand = Boolean(action.runCommand || action.runShellCommand);
						const result = await this.#handleWorkflowAction(action, {
							workspaceFolderPath,
							workspaceFolderUri,
							workflowId,
							workflowToken,
							fileStateTracker: this.#fileStateTracker,
							abortSignal
						});
						const wasUserInterrupted = abortSignal.aborted && abortSignal.reason instanceof Error && abortSignal.reason.message === "Command was interrupted by the user";
						if (!abortSignal.aborted || wasUserInterrupted) this.#stream?.write(this.#createResponse(result, action.requestID));
					}
				} catch (error) {
					this.#prefixedLogger.error("Error handling workflow action", error);
					eventQueue.push(new WorkflowExecutorError("Error handling workflow action", WorkflowStatusCode.GENERAL_FAILURE));
				} finally {
					this.#isRunningCommand = false;
				}
			});
			this.#stream.on("error", (error) => {
				this.#prefixedLogger.error("Stream error event received", error);
				this.#prefixedLogger.error(`Error details: ${JSON.stringify({
					message: error.message,
					code: error.code,
					details: error.details,
					metadata: error.metadata
				})}`);
				this.#resetActionHandlerAbortController();
				const statusCode = mapClientErrorToUserFacingStatusCode(error);
				const message = `${LOGGER_PREFIX} Stream encountered error (code: ${statusCode})`;
				this.#errorHandler.handleError(message, new SanitizedError(message, error), {
					correlationId: this.#client?.getCorrelationId(),
					statusCode
				});
				eventQueue.push({
					type: "completion",
					statusCode
				});
			});
			this.#stream.on("end", () => {
				this.#prefixedLogger.debug("Stream end event received");
				this.#resetActionHandlerAbortController();
				eventQueue.push({
					type: "completion",
					statusCode: WorkflowSuccessCode
				});
			});
			if (toolApproval && "userApproved" in toolApproval && toolApproval.userApproved) try {
				const capabilities = this.#workflowTokenService.getServerCapabilities({
					workflowDefinition,
					workflowId
				});
				if (toolApproval.type === ToolApprovalType.APPROVE_FOR_SESSION && toolApproval.toolArgs) await persistToolApprovalForSession({
					workflowId,
					toolName: toolApproval.toolName,
					toolArgs: toolApproval.toolArgs,
					gitlabApiService: this.#gitlabApiService,
					logger: this.#prefixedLogger,
					capabilities,
					mcpToolApprovalController: this.#mcpToolApprovalController,
					approvalSource: toolApproval.approvalSource
				});
				else if (toolApproval.type === ToolApprovalType.APPROVE_PATTERN_FOR_SESSION && toolApproval.pattern) await persistPatternApprovalForSession({
					workflowId,
					toolName: toolApproval.toolName,
					pattern: toolApproval.pattern,
					gitlabApiService: this.#gitlabApiService,
					logger: this.#prefixedLogger,
					capabilities,
					approvalSource: toolApproval.approvalSource
				});
			} catch (e) {
				this.#prefixedLogger.warn(`Failed to persist tool approval; continuing: ${String(e)}`);
			}
			const mcpTools = options.excludeMcpTools ? [] : await this.#mcpManager.reload(workspaceFolderPath, workflowId);
			const approvedTools = mcpTools?.filter((x) => x.isApproved).map((x) => x.name) ?? [];
			const servers = Array.from(new Set(mcpTools.map((x) => x.serverName)));
			this.#prefixedLogger.info(`startRequest: mcp_tools=${mcpTools.length} preapproved_tools=${approvedTools.length} servers=${servers.length}`);
			this.#prefixedLogger.debug(`startRequest: approved_tools=${truncateToByteLimit(JSON.stringify(approvedTools), 1024, { suffix: "...[truncated]" })}`);
			try {
				const writeResult = this.#stream.write({ startRequest: {
					workflowID: workflowId,
					clientVersion: "1.0",
					workflowDefinition,
					goal: toolApproval ? "" : goal,
					workflowMetadata: JSON.stringify(workflowMetadata),
					additional_context: toolApproval ? [] : this.#processAdditionalContext(options.additionalContext),
					clientCapabilities: supportsScheduledWakes ? [...CLIENT_CAPABILITIES, SCHEDULE_NOTIFICATION_CAPABILITY] : CLIENT_CAPABILITIES,
					mcpTools,
					preapproved_tools: approvedTools,
					flowConfig: tryParseFlowConfig(flowConfig),
					flowConfigSchemaVersion: flowConfigSchemaVersion ?? tryParseFlowConfig(flowConfig)?.version ?? void 0,
					flowConfigId,
					flowVersion,
					streaming,
					approval: (toolApproval && {
						approval: toolApproval.userApproved === true ? { approval_source: toolApproval.approvalSource ? approval_ApprovalSourceFromJSON(`APPROVAL_SOURCE_${toolApproval.approvalSource}`) : void 0 } : void 0,
						rejection: toolApproval.userApproved === false ? { message: toolApproval.message } : void 0
					}) ?? void 0
				} });
				this.#prefixedLogger.debug(`startRequest write returned: ${writeResult}`);
			} catch (writeError) {
				this.#prefixedLogger.error("Error during write call", writeError);
				throw writeError;
			}
			this.#prefixedLogger.debug("startRequest written to stream");
			this.#prefixedLogger.debug("Entering event queue iteration...");
			for await (const event of eventQueue) yield event;
			this.#prefixedLogger.debug("Event queue iteration completed");
		} catch (error) {
			const isDuoAccessError = isAgenticChatForbiddenError(error) || isNoDuoNamespaceError(error);
			let statusCode;
			let userFacingMessage;
			if (isDuoAccessError) {
				statusCode = WorkflowStatusCode.NO_DUO_ACCESS;
				userFacingMessage = error.message;
			} else {
				statusCode = resolveWorkflowStatusCode(error, mapClientErrorToUserFacingStatusCode);
				userFacingMessage = generateErrorMessageFromStatusCode(statusCode);
			}
			const message = `${LOGGER_PREFIX} Workflow execution failed`;
			this.#errorHandler.handleError(message, new SanitizedError(message, error), {
				correlationId: this.#client?.getCorrelationId(),
				statusCode
			});
			yield new WorkflowExecutorError(userFacingMessage, statusCode);
		}
	}
	async #handleWorkflowCheckpoint(workflowId, action) {
		this.#prefixedLogger.debug(`Received new checkpoint: ${JSON.stringify({ workflowStatus: action.newCheckpoint.status })}`);
		if (this.#currentWorkflowStatus !== action.newCheckpoint.status) {
			if (action.newCheckpoint.status === DuoWorkflowStatus.CREATED) this.#duoWorkflowTracker.trackEvent(DUO_WORKFLOW_EVENT.START, { workflow_id: workflowId });
			else if (action.newCheckpoint.status === DuoWorkflowStatus.FINISHED) this.#duoWorkflowTracker.trackEvent(DUO_WORKFLOW_EVENT.FINISH, { workflow_id: workflowId });
			this.#currentWorkflowStatus = action.newCheckpoint.status;
		}
		return {
			checkpoint: this.#mergeCheckpointChatLog(action.newCheckpoint.checkpoint),
			errors: action.newCheckpoint.errors,
			workflowStatus: action.newCheckpoint.status,
			workflowGoal: action.newCheckpoint.goal,
			agentContextUsage: this.#mapAgentContextUsage(action.newCheckpoint.agent_context_usage)
		};
	}
	/** Returns undefined when there is no usage data so consumers can treat it as "no data". */
	#mapAgentContextUsage(agentContextUsage) {
		if (!agentContextUsage) return void 0;
		const entries = Object.entries(agentContextUsage);
		if (entries.length === 0) return void 0;
		return Object.fromEntries(entries.map(([agent, usage]) => [agent, {
			totalTokens: usage.total_tokens,
			maxTokens: usage.max_tokens
		}]));
	}
	/**
	* Parses the raw checkpoint JSON, merges any incremental ui_chat_log slice
	* into the accumulated full log, and returns the updated checkpoint JSON string.
	*
	* When `incremental_streaming` is active, DWS omits already-sent messages from
	* the checkpoint's `ui_chat_log`, sending only the delta. This method reconstructs
	* the full log so all consumers downstream see a complete history.
	*/
	#mergeCheckpointChatLog(rawCheckpoint) {
		if (!rawCheckpoint) return rawCheckpoint;
		let parsed;
		try {
			parsed = JSON.parse(rawCheckpoint);
		} catch {
			this.#logger.warn("Failed to parse raw checkpoint data, invalid JSON");
			return rawCheckpoint;
		}
		const incomingLog = parsed?.channel_values?.ui_chat_log;
		if (!Array.isArray(incomingLog)) return rawCheckpoint;
		this.#accumulatedChatLog = mergeIncrementalChatLog(this.#accumulatedChatLog, incomingLog);
		const merged = {
			...parsed,
			channel_values: {
				...parsed.channel_values,
				ui_chat_log: this.#accumulatedChatLog
			}
		};
		return JSON.stringify(merged);
	}
	async #handleWorkflowAction(action, context) {
		const actionType = Object.keys(action).find((key) => key !== "requestID" && action[key] !== void 0);
		let workflowActionLogger = withPrefix(this.#prefixedLogger, `[actionType: ${actionType ?? "missing_workflow_action"}]`);
		if (action?.requestID?.length) workflowActionLogger = withPrefix(this.#prefixedLogger, `[requestID: ${action.requestID}]`);
		workflowActionLogger.debug(`Action received: ${this.#secretRedactor.redactSecrets(JSON.stringify(action), "workflow-action")}`);
		try {
			if (this.#actionHandlerAbortController?.signal.aborted) return {
				response: "",
				error: "Action not executed because workflow has been cancelled or stopped"
			};
			const result = await this.#actionExecutor.execute(action, context);
			return this.#applySecretRedaction(result, `${actionType}_tool_output`);
		} catch (err) {
			const error = err instanceof Error ? err.message : String(err);
			workflowActionLogger.error(`Error handling action: ${error}`);
			return this.#applySecretRedaction({
				error,
				response: ""
			}, `${actionType}_tool_execution_error`);
		}
	}
	#applySecretRedaction(result, resultSource) {
		if (isScheduleNotificationResponse(result)) return result;
		if (isPlaintextResponse(result)) {
			const { redacted, ranges: redactedRanges } = this.#secretRedactor.redactSecretsWithRanges(result.response, resultSource);
			let redactionNote = "";
			const redactionCount = redactedRanges.length;
			if (redactionCount > 0) {
				const pluralisedSecrets = `${redactionCount} secret${redactionCount === 1 ? "" : "s"}`;
				const pluralisedRangesText = `${redactionCount === 1 ? "This range contains" : "These ranges contain"}`;
				redactionNote = `\n\n---\nNote: ${pluralisedSecrets} redacted at: ${redactedRanges.map((range) => formatRangeLocation(range)).join(", ")}. ${pluralisedRangesText} asterisks (*) replacing actual values and cannot be edited.`;
			}
			return {
				response: `${redacted}${redactionNote}`,
				error: this.#secretRedactor.redactSecrets(result.error, resultSource)
			};
		}
		return {
			...result,
			body: this.#secretRedactor.redactSecrets(result.body, resultSource),
			error: this.#secretRedactor.redactSecrets(result.error, resultSource)
		};
	}
	#createWorkflowClient(workflowMetadata, resolvedModel, agentPlatformFeatureSettingName, langsmithTrace, workflowOptions) {
		const clientMetadata = {
			...workflowMetadata,
			selectedModelIdentifier: resolvedModel
		};
		if (!this.#socketConnectionDetails) throw new WorkflowExecutorError("Tried to create a WebSocket client before the GitLab API configuration data was available.", WorkflowStatusCode.INVALID_API_CONFIGURATION);
		try {
			return new WebSocketWorkflowClient(this.#logger, this.#webSocketFactory, this.#sslConfig, this.#socketConnectionDetails, clientMetadata, this.#gitlabApiService.instanceInfo, this.#telemetry, agentPlatformFeatureSettingName, workflowOptions, langsmithTrace);
		} catch (err) {
			this.#logger.error("Failed to create WebSocket client: ", err);
			throw new WorkflowExecutorError("Failed to create WebSocket client", WorkflowStatusCode.SERVICE_CONNECTION_FAILED);
		}
	}
	async #workflowMetadata(workspaceFolderPath) {
		const metadata = {};
		const repo = (await this.#repositoryDiscoveryService.getRepositoriesForWorkspace(workspaceFolderPath)).values().next().value;
		if (repo) {
			const remotes = await repo.listRemotes();
			metadata.git_url = (remotes.find((r) => r.remote === "origin") ?? remotes[0])?.url;
			metadata.git_sha = await repo.getCurrentCommit() || void 0;
			metadata.git_branch = await repo.getCurrentBranchName() || void 0;
		}
		return metadata;
	}
	#createResponse(response, requestID) {
		if (isScheduleNotificationResponse(response)) return { actionResponse: {
			requestID,
			scheduleNotificationResponse: response
		} };
		const clientEvent = { actionResponse: {
			requestID,
			...isPlaintextResponse(response) ? { plainTextResponse: response } : { httpResponse: response }
		} };
		if (!this.#client) throw new Error("Workflow client is not initialized. This should not happen during response creation.");
		try {
			const responseSize = this.#client.getResponseByteSize(clientEvent);
			if (responseSize <= 4194304) return clientEvent;
			return createSizeLimitExceededResponse(response, requestID, responseSize, MAX_MESSAGE_SIZE);
		} catch (serializationError) {
			this.#prefixedLogger.error("Failed to serialize ClientEvent for size check", serializationError);
			return createSerializationErrorResponse(response, requestID);
		}
	}
	#processAdditionalContext(additionalContext = []) {
		const fileContentProviders = [
			"open_tab",
			"local_file_search",
			"import"
		];
		additionalContext.forEach((context) => {
			if (context.category === "file" && context.content && context.id && context.metadata?.subType && fileContentProviders.includes(context.metadata.subType)) try {
				const filePath = context.id.startsWith("file://") ? decodeURIComponent(context.id.replace("file://", "")) : context.id;
				this.#fileStateTracker.recordFileRead(filePath, context.content);
				this.#prefixedLogger.debug(`Pre-populated file state for: ${filePath}`);
			} catch (error) {
				this.#prefixedLogger.warn(`Failed to pre-populate file state for context item ${context.id}`, error);
			}
		});
		return additionalContext.map((context) => ({
			...context,
			metadata: JSON.stringify(context.metadata)
		}));
	}
	async #getAuthToken(workflowId, workflowDefinition, rootNamespaceId, projectPath) {
		try {
			return await this.#workflowTokenService.getToken(workflowId, workflowDefinition, rootNamespaceId, projectPath);
		} catch (error) {
			if (isAgenticChatForbiddenError(error) || isNoDuoNamespaceError(error)) throw error;
			this.#logger.debug(`Rejecting with status code ${WorkflowStatusCode.AUTH_TOKEN_FETCH_ERROR}`);
			throw new WorkflowExecutorError("Failed to fetch authentication token", WorkflowStatusCode.AUTH_TOKEN_FETCH_ERROR);
		}
	}
	static {
		_initClass$24();
	}
});
//#endregion
//#region src/executors/node/node_executor_with_retry.ts
let _initClass$23;
function _applyDecs$23(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName$23(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName$23(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey$23(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS$23(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey$23(t) {
	var i = _toPrimitive$23(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$23(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName$23(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS$23(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
const NodeExecutorWithRetry = createInterfaceId("NodeExecutor");
/**
* Maximum number of retry attempts for workflow execution.
* With exponential backoff (base 1s, exponent 2), retries are spread
* across the stop-handshake window so that if the previous session stops quickly,
* an earlier retry will succeed rather than waiting a fixed initial delay.
*
* Delay schedule: 0s → 1s → 2s → 4s → 8s
*/
const MAX_EXECUTOR_RETRY_ATTEMPTS = 5;
/**
* Shown when an empty-goal reconnect is rejected with BAD_REQUEST (workhorse
* close 4400). The server has confirmed the workflow is parked at a stable pause
* boundary awaiting real user input, so the interrupted turn produced no response
* and the user needs to send their message again. BAD_REQUEST is transient, so
* the workflow stays reusable for that next message.
*/
const TURN_INTERRUPTED_MESSAGE = "Your message was interrupted before GitLab Duo could process it. GitLab Duo is paused and waiting for your input — please send your message again.";
let _DefaultNodeExecutorW;
(class {
	static {
		[_DefaultNodeExecutorW, _initClass$23] = _applyDecs$23(this, [Service({
			dependencies: [
				DuoWorkflowTracker,
				NodeExecutor,
				Logger,
				WorkflowTokenService
			],
			lifetime: ServiceLifetime.Transient
		}), Implements(NodeExecutorWithRetry)], []).c;
	}
	#nodeExecutor;
	#logger;
	#workflowTokenService;
	#abortPendingRetryController = new AbortController();
	constructor(_duoWorkflowTracker, nodeExecutor, logger, workflowTokenService) {
		this.#nodeExecutor = nodeExecutor;
		this.#logger = logger;
		this.#workflowTokenService = workflowTokenService;
	}
	async disposeAsync() {
		await this.#nodeExecutor.disposeAsync();
	}
	async *runWorkflow(opts) {
		this.#abortPendingRetryController = new AbortController();
		try {
			for (let attempt = 1; attempt <= MAX_EXECUTOR_RETRY_ATTEMPTS; attempt++) {
				if (this.#abortPendingRetryController.signal.aborted) return;
				try {
					const runOpts = attempt > 1 ? {
						...opts,
						goal: ""
					} : opts;
					const result = yield* this.#attemptWorkflowExecution(runOpts, attempt);
					if (!result.needsRetry) return;
					if (this.#shouldStopForReconnectRejection(result.lastStatusCode)) {
						yield* this.#emitTurnInterrupted();
						return;
					}
					const backoffMs = calculateExponentialBackoff(attempt);
					yield this.#createRetryEvent(attempt, backoffMs);
					await delay(backoffMs, this.#abortPendingRetryController.signal);
					if (this.#abortPendingRetryController.signal.aborted) return;
				} catch (error) {
					const statusCode = resolveWorkflowStatusCode(error);
					if (this.#shouldAttemptRetry(attempt, statusCode)) {
						if (this.#shouldStopForReconnectRejection(statusCode)) {
							yield* this.#emitTurnInterrupted();
							return;
						}
						const message = generateErrorMessageFromStatusCode(statusCode);
						this.#logger.warn(`Workflow execution failed, retrying (${attempt}/${MAX_EXECUTOR_RETRY_ATTEMPTS}): ${message}`);
						const backoffMs = calculateExponentialBackoff(attempt);
						yield this.#createRetryEvent(attempt, backoffMs);
						await delay(backoffMs, this.#abortPendingRetryController.signal);
						if (this.#abortPendingRetryController.signal.aborted) return;
					} else {
						this.#logger.error(`Max retries exceeded or non-retryable error: ${generateErrorMessageFromStatusCode(statusCode)}`);
						yield new WorkflowExecutorError(WorkflowStatusCodeMessages[statusCode] || generateErrorMessageFromStatusCode(statusCode), statusCode);
						return;
					}
				}
			}
		} finally {
			await this.#revokeActiveToken(opts);
		}
	}
	async #revokeActiveToken(opts) {
		const { workflowId } = opts;
		const workflowDefinition = resolveWorkflowDefinition(opts.workflowDefinition);
		if (workflowDefinition === WorkflowDefinition.CHAT) return;
		const token = this.#workflowTokenService.getTokenFromCache({
			workflowDefinition,
			workflowId
		});
		if (!token) return;
		try {
			await this.#workflowTokenService.revokeToken(workflowId, token);
		} catch {}
	}
	async *#attemptWorkflowExecution(opts, attempt) {
		const workflowEvents = this.#nodeExecutor.runWorkflow(opts);
		for await (const event of workflowEvents) {
			if (!isWorkflowExecutorErrorEvent(event)) {
				yield event;
				continue;
			}
			if (this.#shouldAttemptRetry(attempt, event.statusCode)) {
				const message = generateErrorMessageFromStatusCode(event.statusCode);
				this.#logger.warn(`Workflow execution failed, retrying (${attempt}/${MAX_EXECUTOR_RETRY_ATTEMPTS}): ${message}`);
				return {
					needsRetry: true,
					lastStatusCode: event.statusCode
				};
			}
			this.#logger.error(`Max retries exceeded or non-retryable error: ${generateErrorMessageFromStatusCode(event.statusCode)}`);
			yield event;
			return { needsRetry: false };
		}
		return { needsRetry: false };
	}
	#createRetryEvent(attempt, backoffMs) {
		return {
			kind: "retry",
			attempt,
			maxAttempts: MAX_EXECUTOR_RETRY_ATTEMPTS,
			backoffMs
		};
	}
	/**
	* Whether the loop should stop instead of replaying the turn with an empty goal.
	* True when the server rejected the empty-goal reconnect with BAD_REQUEST
	* (workhorse close 4400) — the server-authoritative confirmation that the
	* workflow is parked at a stable pause boundary awaiting real user input. Only
	* the developer V1 Flow engine produces this rejection; agentic chat treats an
	* empty goal as a valid reconnect, so it never reaches this branch.
	* See gitlab-org/gitlab#602799.
	*/
	#shouldStopForReconnectRejection(statusCode) {
		return statusCode === WorkflowStatusCode.BAD_REQUEST;
	}
	/**
	* End the retry loop instead of replaying the turn with an empty goal, because
	* the server rejected the reconnect with BAD_REQUEST — confirming the workflow
	* is parked at a stable pause boundary. We surface a turn-interrupted error so
	* the user knows their message was not processed and should be resent (and so
	* headless runs exit non-zero rather than reporting success). BAD_REQUEST is
	* transient, so the workflow stays reusable for that next message.
	*/
	async *#emitTurnInterrupted() {
		this.#logger.info("Empty-goal reconnect was rejected as BAD_REQUEST; the workflow is paused awaiting user input. Surfacing a turn-interrupted error instead of retrying.");
		yield new WorkflowExecutorError(TURN_INTERRUPTED_MESSAGE, WorkflowStatusCode.BAD_REQUEST);
	}
	#shouldAttemptRetry(attempt, statusCode) {
		return attempt < MAX_EXECUTOR_RETRY_ATTEMPTS && this.#shouldRetryStatusCode(statusCode);
	}
	#shouldRetryStatusCode(statusCode) {
		return ![WorkflowStatusCode.AUTH_TOKEN_ERROR, WorkflowStatusCode.INVALID_API_CONFIGURATION].includes(statusCode);
	}
	stopWorkflow() {
		this.#abortPendingRetryController.abort();
		this.#nodeExecutor.stopWorkflow();
	}
	interruptRunningCommand() {
		this.#nodeExecutor.interruptRunningCommand();
	}
	isCommandRunning() {
		return this.#nodeExecutor.isCommandRunning();
	}
	static {
		_initClass$23();
	}
});
//#endregion
//#region src/executors/executor_manager.ts
const EXECUTOR_IDLE_DISPOSE_TIME_MS = 1800 * 1e3;
const ExecutorManager = createInterfaceId("ExecutorManager");
var DefaultExecutorManager = class {
	#nodeExecutors = /* @__PURE__ */ new Map();
	#logger;
	#container;
	constructor(container, logger) {
		this.#container = container;
		this.#logger = withPrefix(logger, "[ExecutorManager]");
	}
	getExecutorForWorkflow(workflowId) {
		if (!this.#nodeExecutors.has(workflowId)) this.#nodeExecutors.set(workflowId, { executor: this.#createExecutor() });
		return this.#nodeExecutors.get(workflowId).executor;
	}
	setupExecutorDisposal(workflowId) {
		const executorEntry = this.#nodeExecutors.get(workflowId);
		if (!executorEntry) return;
		const timeout = setTimeout(() => {
			this.disposeExecutor(workflowId).catch((err) => {
				this.#logger.error(`Error disposing executor for workflow "${workflowId}"`, err);
			});
		}, EXECUTOR_IDLE_DISPOSE_TIME_MS);
		this.#nodeExecutors.set(workflowId, {
			executor: executorEntry.executor,
			disposeTimeout: timeout
		});
	}
	clearExecutorDisposal(workflowId) {
		const executorEntry = this.#nodeExecutors.get(workflowId);
		if (!executorEntry?.disposeTimeout) return;
		clearTimeout(executorEntry.disposeTimeout);
		this.#nodeExecutors.set(workflowId, {
			executor: executorEntry.executor,
			disposeTimeout: void 0
		});
	}
	async disposeExecutor(workflowId) {
		this.#logger.debug(`Disposing executor for workflow "${workflowId}".`);
		const { executor, disposeTimeout } = this.#nodeExecutors.get(workflowId) || {};
		clearTimeout(disposeTimeout);
		await executor?.disposeAsync();
		this.#nodeExecutors.delete(workflowId);
	}
	async disposeAsync() {
		this.#logger.info(`Disposing ExecutorManager (${this.#nodeExecutors.size} active executors)`);
		const workflowIds = [...this.#nodeExecutors.keys()];
		await Promise.all(workflowIds.map((workflowId) => this.disposeExecutor(workflowId)));
	}
	#createExecutor() {
		this.#logger.debug(`Creating Duo Workflow Executor with type "node"`);
		return this.#container.getRequiredService(NodeExecutorWithRetry);
	}
};
//#endregion
//#region src/executors/node/actions/utils/text_edit_utils.ts
const NEWLINE_REGEX = /\r\n|\n|\r/;
/**
* Creates TextEdit objects for replacing all occurrences of oldString with newString.
*/
function createTextEditsFromContent(fullText, oldString, newString) {
	if (!fullText || !oldString || !oldString.length) return [];
	const textEdits = [];
	let searchStart = 0;
	let foundIndex = fullText.indexOf(oldString, searchStart);
	while (foundIndex !== -1) {
		const textEdit = {
			range: {
				start: indexToPosition(fullText, foundIndex),
				end: indexToPosition(fullText, foundIndex + oldString.length)
			},
			newText: newString
		};
		textEdits.push(textEdit);
		searchStart = foundIndex + oldString.length;
		foundIndex = fullText.indexOf(oldString, searchStart);
	}
	return textEdits;
}
/**
* Converts a string index to an LSP Position (line/character coordinates).
*/
function indexToPosition(text, index) {
	const lines = text.substring(0, index).split(NEWLINE_REGEX);
	const lastLine = lines[lines.length - 1] ?? "";
	return {
		line: lines.length - 1,
		character: lastLine.length
	};
}
//#endregion
//#region src/executors/node/actions/utils/path_containment.ts
/**
* Security boundary check: true when `path` is `dir` itself or nested within it.
* Both arguments should already be resolved/real paths so symlinks and `..`
* segments cannot escape the directory.
*/
function isPathContainedIn(dir, path) {
	const rel = relative(dir, path);
	return !rel.startsWith("..") && !isAbsolute(rel);
}
//#endregion
//#region src/executors/node/actions/utils/gitignore_filter.ts
/**
* `.gitignore` evaluation for the node-only file tools, delegated to
* `git check-ignore` (the ground truth) rather than reimplemented, since a
* hand-rolled matcher would silently diverge from git. git is only ever spawned
* inside a repo (guarded by a cheap fs `.git`-walk); outside a repo nothing is
* reported ignored, matching ripgrep's `--require-git` default.
*/
/**
* Filters absolute target paths to those that are `.gitignored`, exactly as git
* would report them. Returns the subset of `absoluteTargets` that are ignored
* (always empty when not inside a git repository — see the module docstring).
*
* Precondition: `anchorDir` is a caller-supplied directory that contains every
* target, so the "all targets live in a single repository" precondition holds
* by construction. The repo is located by walking up from `anchorDir`, so the
* anchor never depends on target `readdir` order or on a target that owns its
* own nested `.git`.
*
* @param anchorDir Absolute directory that contains every target; used to
*   locate the enclosing repository.
* @param absoluteTargets Absolute, realpath-resolved target paths. Callers
*   enforce workspace containment separately.
*/
async function findIgnoredPaths(anchorDir, absoluteTargets) {
	if (absoluteTargets.length === 0) return [];
	const repoRoot = await findGitRepoRoot(anchorDir);
	if (repoRoot === void 0) return [];
	if (!await new DefaultStatelessRepository(repoRoot).isInsideWorkTree()) return [];
	const ignored = await new DefaultStatelessRepository(repoRoot).checkIgnore(absoluteTargets);
	const ignoredSet = new Set(ignored.map((p) => normalize(p)));
	return absoluteTargets.filter((target) => ignoredSet.has(normalize(target)));
}
//#endregion
//#region src/executors/node/actions/assert_accessible_file.ts
/**
* Safety guard for the node-only file tools (read/write/edit/mkdir/grep).
*
* Replaces the previous "file must be in a git repository" gate. The security
* boundary is path containment: the target is resolved through realPath
* (symlink-resolved) and must stay within the resolved workspace folder.
* `.gitignore` is additionally enforced via {@link findIgnoredPaths}.
*
* Virtual workspaces (`adt://`, `semanticfs://`, ...) skip all validation, as
* before — their files are managed by the IDE and are not backed by a local FS.
*
* Returns the symlink-resolved (`realPath`) absolute path of the target so
* callers (e.g. `list_dir`) can reuse it. For virtual workspaces the plain
* `join(workspaceFolderPath, filePath)` is returned instead.
*/
async function assertAccessibleFile(filePath, workspaceFolderPath, fileAccessService, logger, workspaceFolderUri) {
	const fullFilePath = join(workspaceFolderPath, filePath);
	if (isVirtualWorkspaceUri(workspaceFolderUri)) {
		logger.debug(`Skipping file access validation for virtual workspace: ${workspaceFolderUri}`);
		return fullFilePath;
	}
	const fullRealFilePath = await fileAccessService.realPath(fullFilePath);
	if (fullRealFilePath === "") {
		const errorMessage = `Path did not refer to a valid file or symlink: "${filePath}" could not be resolved`;
		logger.error(errorMessage);
		throw new Error(errorMessage);
	}
	logger.debug(`Path "${filePath}" resolved to "${fullRealFilePath}"`);
	const realWorkspaceFolderPath = await fileAccessService.realPath(workspaceFolderPath);
	if (realWorkspaceFolderPath === "") {
		const errorMessage = `Workspace folder path could not be resolved: "${workspaceFolderPath}"`;
		logger.error(errorMessage);
		throw new Error(errorMessage);
	}
	if (!isPathContainedIn(realWorkspaceFolderPath, fullRealFilePath)) {
		const errorMessage = fullFilePath !== fullRealFilePath ? `Path is outside the workspace folder: "${filePath}" points to "${fullRealFilePath}"` : `Path is outside the workspace folder: "${filePath}"`;
		logger.error(errorMessage);
		throw new Error(errorMessage);
	}
	if ((await findIgnoredPaths(realWorkspaceFolderPath, [fullRealFilePath])).length > 0) {
		const errorMessage = `Cannot access "${fullRealFilePath}": it is excluded by .gitignore and access to gitignored paths is intentionally disabled.`;
		logger.error(errorMessage);
		throw new Error(errorMessage);
	}
	return fullRealFilePath;
}
//#endregion
//#region src/executors/node/actions/index.ts
const WorkflowActionHandler = createInterfaceId("WorkflowActionHandler");
/**
* Maps a tool's raw protocol args to a {@link ToolInputDisplay}. This is a
* display concern, decoupled from tool execution ({@link WorkflowActionHandler}).
*/
const ToolInputFormatter = createInterfaceId("ToolInputFormatter");
//#endregion
//#region src/executors/node/actions/edit_file.ts
let _initClass$22, _initClass2$11;
function _applyDecs$22(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName$22(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName$22(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey$22(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS$22(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey$22(t) {
	var i = _toPrimitive$22(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$22(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName$22(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS$22(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
const editFileArgsSchema = z.object({
	file_path: z.string(),
	old_str: z.string(),
	new_str: z.string()
});
let _EditFileFormatter;
(class {
	static {
		[_EditFileFormatter, _initClass$22] = _applyDecs$22(this, [Injectable(ToolInputFormatter, [Logger, collection(FileAccessService)])], []).c;
	}
	#logger;
	#fileAccessService;
	constructor(logger, fileAccessServices) {
		this.#logger = withPrefix(logger, "[EditFileFormatter]");
		this.#fileAccessService = createFallbackService(this.#logger, fileAccessServices);
	}
	toolName = "edit_file";
	async format(args, { workspaceFolderPath }) {
		const { file_path: filepath, old_str: oldStr, new_str: newStr } = editFileArgsSchema.parse(args);
		try {
			const fullFilePath = join(workspaceFolderPath, filepath);
			const currentContent = await this.#fileAccessService.getText(fullFilePath);
			const fileEol = detectEol(currentContent);
			const oldStrWithEol = applyEol(oldStr, fileEol);
			const newStrWithEol = applyEol(newStr, fileEol);
			const fileAlreadyEdited = currentContent.includes(newStrWithEol);
			let originalContent;
			let newContent;
			if (fileAlreadyEdited) {
				originalContent = currentContent.replace(newStrWithEol, oldStrWithEol);
				newContent = currentContent;
			} else {
				originalContent = currentContent;
				newContent = currentContent.replace(oldStrWithEol, newStrWithEol);
			}
			return {
				tool: "edit_file",
				filepath,
				diff: {
					old: {
						filepath,
						content: originalContent
					},
					new: {
						filepath,
						content: newContent
					}
				}
			};
		} catch (error) {
			this.#logger.warn(`Could not read file for full diff display: ${filepath}`, error);
			return {
				tool: "edit_file",
				filepath,
				diff: {
					old: {
						filepath,
						content: oldStr
					},
					new: {
						filepath,
						content: newStr
					}
				}
			};
		}
	}
	static {
		_initClass$22();
	}
});
let _EditFileActionHandle;
(class {
	static {
		[_EditFileActionHandle, _initClass2$11] = _applyDecs$22(this, [Injectable(WorkflowActionHandler, [
			Logger,
			collection(FileAccessService),
			DocumentQualityService,
			FeatureFlagService
		])], []).c;
	}
	#logger;
	#fileAccessService;
	#documentQualityService;
	#featureFlagService;
	constructor(logger, fileAccessServices, documentQualityService, featureFlagService) {
		this.#logger = withPrefix(logger, "[EditFileActionHandler]");
		this.#fileAccessService = createFallbackService(this.#logger, fileAccessServices);
		this.#documentQualityService = documentQualityService;
		this.#featureFlagService = featureFlagService;
	}
	name = "edit_file";
	canHandle(action) {
		return Boolean(action.runEditFile);
	}
	async execute({ runEditFile }, { workspaceFolderPath, workspaceFolderUri, fileStateTracker, abortSignal }) {
		const filePath = runEditFile.filepath;
		for (const pattern of [
			/(^|[/\\])\.gitlab[/\\]duo[/\\]/,
			/(^|[/\\])\.git[/\\]/,
			/(^|[/\\])\.metadata[/\\]/,
			/(^|[/\\])\.idea[/\\].*\.xml$/,
			/(^|[/\\])\.vscode[/\\]settings\.json$/,
			/(^|[/\\])\.nvimrc$/,
			/(^|[/\\])\.vimrc$/,
			/(^|[/\\])init\.lua$/
		]) if (filePath.match(pattern)) return {
			error: "You are not allowed to change editor configuration files or sensitive directories",
			response: ""
		};
		const fullFilePath = join(workspaceFolderPath, filePath);
		const lookupKey = fileLookupKey(workspaceFolderPath, workspaceFolderUri, filePath);
		let originalContent = "";
		try {
			await assertAccessibleFile(filePath, workspaceFolderPath, this.#fileAccessService, this.#logger, workspaceFolderUri);
			this.#logger.debug(`Reading file "${filePath}" for editing`);
			originalContent = await this.#fileAccessService.getText(lookupKey);
		} catch (error) {
			const errorMessage = error.message;
			this.#logger.error(`Unable to open file "${filePath}": ${errorMessage}`);
			return {
				error: `Unable to open file: ${errorMessage}`,
				response: ""
			};
		}
		try {
			fileStateTracker.assertFileNotModifiedSinceLastRead(workspaceFolderPath, filePath, originalContent);
		} catch (error) {
			if (error instanceof DuoFileNotReadError || error instanceof DuoFileModifiedSinceLastReadError) {
				this.#logger.debug(`Can't edit file: "${error.message}"`);
				return {
					error: error.message,
					response: ""
				};
			}
			this.#logger.error(`Failed to verify if Duo has already read file before editing for: "${filePath}"`, error);
		}
		const fileEol = detectEol(originalContent);
		const oldString = applyEol(runEditFile.oldString, fileEol);
		const newString = applyEol(runEditFile.newString, fileEol);
		if (!originalContent.includes(oldString)) return {
			response: `No changes made to '${filePath}' as '${runEditFile.oldString}' not found`,
			error: ""
		};
		if (originalContent.split(oldString).length - 1 > 1) return {
			response: "",
			error: "Ambiguous match: \"oldText\" appears multiple times. Provide more surrounding code to make the replacement match unique."
		};
		const textEdits = createTextEditsFromContent(originalContent, oldString, newString);
		const editedRanges = textEdits.map((edit) => edit.range);
		if (textEdits.length === 0) return {
			response: `No changes made to '${filePath}' as text edit range could not be determined.`,
			error: ""
		};
		try {
			abortSignal.throwIfAborted();
			await this.#fileAccessService.updateFile(lookupKey, textEdits, originalContent);
		} catch (error) {
			const errorMessage = error instanceof Error ? error.message : String(error);
			this.#logger.error(`Error updating file "${fullFilePath}"`, error);
			return {
				error: errorMessage,
				response: ""
			};
		}
		await this.#updateFileState(fileStateTracker, fullFilePath, filePath, lookupKey);
		if (!this.#featureFlagService.isClientFlagEnabled(ClientFeatureFlags.EditFileDiagnosticsResponse)) return {
			response: `File '${filePath}' has been updated.`,
			error: ""
		};
		return this.#getResponse(filePath, lookupKey, editedRanges);
	}
	async #getResponse(filePath, lookupKey, editedRanges) {
		let diagnostics = [];
		try {
			diagnostics = await this.#documentQualityService.getDiagnostics(URI.parse(lookupKey));
		} catch (err) {
			this.#logger.error(`Failed to get IDE diagnostics for "${filePath}", tool response will omit this`, err);
		}
		const relevantDiagnostics = diagnostics.filter((d) => {
			return rangeOverlapsAny(d.range, editedRanges);
		});
		let response = `File '${filePath}' has been updated.`;
		if (relevantDiagnostics.length) {
			const pluralisedIssues = relevantDiagnostics.length > 1 ? "issues" : "issue";
			const formattedDiagnostics = relevantDiagnostics.map((d) => `* ${formatDiagnostic(d)}`).join("\n");
			response += ` IDE reported ${relevantDiagnostics.length} diagnostic ${pluralisedIssues} in the edited range which may require additional changes to fix:\n${formattedDiagnostics}`;
		}
		this.#logger.debug(response);
		return {
			response,
			error: ""
		};
	}
	/**
	* Update our file state tracker now that the file has been edited, so that Duo does not need to
	* re-read the file for subsequent edits since it knows the current edited state.
	*/
	async #updateFileState(fileStateTracker, fullFilePath, filePath, lookupKey) {
		try {
			const updatedContent = await this.#fileAccessService.getText(lookupKey);
			fileStateTracker.recordFileRead(fullFilePath, updatedContent);
		} catch (contentUpdateError) {
			this.#logger.warn(`Failed to update version cache after edit for "${filePath}"`, contentUpdateError);
		}
	}
	static {
		_initClass2$11();
	}
});
//#endregion
//#region src/services/constants.ts
const RG_BINARY_NAME = `rg${process.platform === "win32" ? ".exe" : ""}`;
//#endregion
//#region src/services/ripgrep_service.ts
let _initClass$21;
function _applyDecs$21(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName$21(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName$21(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey$21(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS$21(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey$21(t) {
	var i = _toPrimitive$21(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$21(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName$21(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS$21(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
const execFileAsync = promisify(execFile);
/**
* Resolve the rg binary to use:
* - RgBinaryProvider: for CLI (Bun-embedded) and LS SEA builds (SEA-embedded)
* - Bundled (IS_BUNDLED inlined as "true" by esbuild): rg is copied alongside the bundle
*   by the extension build (common_jobs.mjs), so look next to __dirname.
* - Watch mode / npm: packagedRgPath from @vscode/ripgrep exists on disk, use it.
* - Fallback: system rg.
*/
async function resolveRgBinary(rgBinaryProvider) {
	const extractedPath = await rgBinaryProvider.getPath();
	if (extractedPath) return extractedPath;
	if (process.env.IS_BUNDLED === "true") return join(__dirname, RG_BINARY_NAME);
	if (existsSync(rgPath)) return rgPath;
	return "rg";
}
async function isRipgrepAvailable(rgBinary) {
	try {
		await execFileAsync(rgBinary, ["--version"]);
		return true;
	} catch {
		return false;
	}
}
/** ripgrep exits with code 1 when there are no matches/files — not an error. */
function isNoMatchExitCode(error) {
	return error !== null && typeof error === "object" && "code" in error && error.code === 1;
}
const RipgrepService = createInterfaceId("RipgrepService");
let _DefaultRipgrepServic;
(class {
	static {
		[_DefaultRipgrepServic, _initClass$21] = _applyDecs$21(this, [Service({
			dependencies: [Logger, RgBinaryProvider],
			lifetime: ServiceLifetime.Singleton
		}), Implements(RipgrepService)], []).c;
	}
	#availability;
	#logger;
	#rgBinaryProvider;
	constructor(logger, rgBinaryProvider) {
		this.#logger = withPrefix(logger, "[RipgrepService]");
		this.#rgBinaryProvider = rgBinaryProvider;
		this.#logger.info("initialized, rg binary is resolved on first use");
	}
	#resolveBinary() {
		return resolveRgBinary(this.#rgBinaryProvider);
	}
	async isAvailable() {
		const binary = await this.#resolveBinary();
		if (this.#availability?.binary !== binary) {
			this.#logger.info(`rg binary resolved to "${binary}", exists=${existsSync(binary)}`);
			this.#availability = {
				binary,
				available: isRipgrepAvailable(binary)
			};
		}
		return this.#availability.available;
	}
	async grep(rootPath, params) {
		const rgBinary = await this.#resolveBinary();
		const args = [
			"--no-heading",
			"--line-number",
			"--with-filename",
			"--no-messages"
		];
		if (params.caseInsensitive) args.push("-i");
		if (params.maxCountFile !== void 0) args.push(`--max-count=${params.maxCountFile}`);
		const searchTerms = Array.isArray(params.searchQuery) ? params.searchQuery : [params.searchQuery];
		for (const term of searchTerms) args.push("-e", term);
		args.push("--", join(rootPath, params.searchDirectory));
		let stdout;
		try {
			stdout = (await execFileAsync(rgBinary, args)).stdout;
		} catch (error) {
			if (isNoMatchExitCode(error)) return {
				paths: /* @__PURE__ */ new Set(),
				results: {}
			};
			throw new Error(`ripgrep failed: ${error}`, { cause: error });
		}
		return this.#parseOutput(stdout, rootPath);
	}
	async listFiles(rootPath, pattern) {
		const allowed = await this.#runFiles(rootPath);
		if (!pattern) return allowed;
		const matched = new Set(await this.#runFiles(rootPath, pattern));
		return allowed.filter((file) => matched.has(file));
	}
	async #runFiles(rootPath, pattern) {
		const rgBinary = await this.#resolveBinary();
		const args = ["--files"];
		if (pattern) args.push("-g", pattern);
		args.push("--", rootPath);
		let stdout;
		try {
			stdout = (await execFileAsync(rgBinary, args)).stdout;
		} catch (error) {
			if (isNoMatchExitCode(error)) return [];
			throw new Error(`ripgrep failed: ${error}`, { cause: error });
		}
		return stdout.split("\n").filter(Boolean).map((absPath) => relative(rootPath, absPath));
	}
	#parseOutput(stdout, repoPath) {
		const paths = /* @__PURE__ */ new Set();
		const results = {};
		for (const line of stdout.split("\n")) if (line && line !== "--") {
			const matchResult = line.match(/^(.+?)([:|-])(\d+)\2(.*)$/);
			if (matchResult) {
				const [, absFilePath, , lineNumStr, preview] = matchResult;
				if (absFilePath && lineNumStr) {
					const filePath = relative(repoPath, absFilePath);
					const lineNum = parseInt(lineNumStr, 10);
					paths.add(filePath);
					if (!results[filePath]) results[filePath] = [];
					results[filePath].push({
						line: lineNum,
						path: filePath,
						preview
					});
				}
			}
		}
		return {
			paths,
			results
		};
	}
	static {
		_initClass$21();
	}
});
//#endregion
//#region src/executors/node/actions/find_files.ts
let _initClass$20, _initClass2$10;
function _applyDecs$20(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName$20(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName$20(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey$20(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS$20(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey$20(t) {
	var i = _toPrimitive$20(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$20(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName$20(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS$20(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
const findFilesArgsSchema = z.object({ name_pattern: z.string() });
let _FindFilesFormatter;
(class {
	static {
		[_FindFilesFormatter, _initClass$20] = _applyDecs$20(this, [Injectable(ToolInputFormatter, [])], []).c;
	}
	toolName = "find_files";
	format(args) {
		const { name_pattern: pattern } = findFilesArgsSchema.parse(args);
		return {
			tool: "find_files",
			pattern
		};
	}
	static {
		_initClass$20();
	}
});
let _FindFilesActionHandl;
(class {
	static {
		[_FindFilesActionHandl, _initClass2$10] = _applyDecs$20(this, [Injectable(WorkflowActionHandler, [Logger, RipgrepService])], []).c;
	}
	#logger;
	#ripgrepService;
	constructor(logger, ripgrepService) {
		this.#logger = withPrefix(logger, "[FindFilesActionHandler]");
		this.#ripgrepService = ripgrepService;
	}
	name = "find_files";
	supportsVirtualWorkspace = false;
	canHandle(action) {
		return Boolean(action.findFiles);
	}
	async execute({ findFiles }, { workspaceFolderPath }) {
		const { name_pattern: namePattern } = findFiles;
		this.#logger.debug(`Finding files in "${workspaceFolderPath}" with pattern "${namePattern}"`);
		if (!await this.#ripgrepService.isAvailable()) return {
			response: "",
			error: "find_files is unavailable: ripgrep could not be located."
		};
		try {
			return {
				response: (await this.#ripgrepService.listFiles(workspaceFolderPath, namePattern)).join("\n"),
				error: ""
			};
		} catch (error) {
			this.#logger.error("find_files failed", error instanceof Error ? error : void 0);
			return {
				response: "",
				error: `${error instanceof Error ? error.message : error}`
			};
		}
	}
	static {
		_initClass2$10();
	}
});
//#endregion
//#region src/executors/node/actions/gitlab_api_request.ts
let _initClass$19;
function _applyDecs$19(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName$19(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName$19(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey$19(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS$19(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey$19(t) {
	var i = _toPrimitive$19(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$19(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName$19(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS$19(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
let _GitlabApiRequestActi;
(class {
	static {
		[_GitlabApiRequestActi, _initClass$19] = _applyDecs$19(this, [Injectable(WorkflowActionHandler, [Logger, GitLabApiService])], []).c;
	}
	#logger;
	#gitLabApiService;
	constructor(logger, gitLabApiService) {
		this.#logger = withPrefix(logger, "[GitlabApiRequestActionHandler]");
		this.#gitLabApiService = gitLabApiService;
	}
	name = "gitlab_api_request";
	canHandle(action) {
		return Boolean(action.runHTTPRequest);
	}
	async execute({ runHTTPRequest }, { workflowToken, abortSignal }) {
		try {
			this.#logger.debug(`Making GitLab API request: ${runHTTPRequest.method} ${runHTTPRequest.path}`);
			const response = await this.#gitLabApiService.getSimpleClient(workflowToken.gitlab_rails.base_url, workflowToken.gitlab_rails.token).fetchFromApiRaw({
				type: "rest",
				method: runHTTPRequest.method,
				path: runHTTPRequest.path,
				body: runHTTPRequest.body && JSON.parse(runHTTPRequest.body),
				signal: abortSignal
			});
			const headers = Object.fromEntries(response.headers.entries());
			const body = await response.text();
			return {
				statusCode: response.status,
				headers,
				body,
				error: ""
			};
		} catch (err) {
			this.#logger.error(`Error making GitLab API request: ${err instanceof Error ? err.message : String(err)}`);
			return {
				error: err instanceof Error ? err.message : String(err),
				body: "",
				statusCode: 0,
				headers: {}
			};
		}
	}
	static {
		_initClass$19();
	}
});
//#endregion
//#region src/executors/node/actions/grep.ts
let _initClass$18, _initClass2$9;
function _applyDecs$18(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName$18(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName$18(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey$18(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS$18(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey$18(t) {
	var i = _toPrimitive$18(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$18(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName$18(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS$18(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
const grepArgsSchema = z.object({
	pattern: z.string().optional(),
	keywords: z.string().optional(),
	search_directory: z.string().optional(),
	case_insensitive: z.boolean().optional()
}).refine((args) => args.pattern != null || args.keywords != null, { message: "Either \"pattern\" or \"keywords\" must be provided" });
let _GrepFormatter;
(class {
	static {
		[_GrepFormatter, _initClass$18] = _applyDecs$18(this, [Injectable(ToolInputFormatter, [])], []).c;
	}
	toolName = "grep";
	format(args) {
		const { pattern, keywords, search_directory: directory, case_insensitive: caseInsensitive } = grepArgsSchema.parse(args);
		return {
			tool: "grep",
			pattern: pattern ?? keywords,
			directory,
			caseInsensitive
		};
	}
	static {
		_initClass$18();
	}
});
const MAX_GREP_COUNT_FILE = 5;
const MAX_SNIPPET_LENGTH = 5e3;
let _GrepActionHandler;
(class {
	static {
		[_GrepActionHandler, _initClass2$9] = _applyDecs$18(this, [Injectable(WorkflowActionHandler, [
			Logger,
			collection(FileAccessService),
			CodeSnippetRanker,
			RipgrepService
		])], []).c;
	}
	#logger;
	#fileAccessService;
	#codeSnippetRanker;
	#ripgrepService;
	constructor(logger, fileAccessServices, ranker, ripgrepService) {
		this.#logger = withPrefix(logger, "[GrepActionHandler]");
		this.#fileAccessService = createFallbackService(logger, fileAccessServices);
		this.#codeSnippetRanker = ranker;
		this.#ripgrepService = ripgrepService;
	}
	name = "grep";
	supportsVirtualWorkspace = false;
	canHandle(action) {
		return Boolean(action.grep);
	}
	async execute({ grep }, { workspaceFolderPath, workspaceFolderUri }) {
		if (isVirtualWorkspaceUri(workspaceFolderUri)) return {
			response: "",
			error: "grep is not supported for virtual filesystem workspaces. The workspace files are managed by the IDE and are not backed by a local git repository."
		};
		const searchDirectory = grep.search_directory || ".";
		try {
			await assertAccessibleFile(searchDirectory, workspaceFolderPath, this.#fileAccessService, this.#logger, workspaceFolderUri);
			if (!await this.#ripgrepService.isAvailable()) return {
				response: "",
				error: "grep is unavailable: ripgrep could not be located."
			};
			const searchTerms = grep.pattern.split(",");
			const grepParams = {
				searchQuery: searchTerms,
				searchDirectory,
				caseInsensitive: grep.case_insensitive,
				maxCountFile: MAX_GREP_COUNT_FILE
			};
			this.#logger.debug(`ripgrep for "${grep.pattern}" — searching in workspace="${workspaceFolderPath}", searchDirectory="${grepParams.searchDirectory}", fullSearchPath="${join(workspaceFolderPath, grepParams.searchDirectory)}"`);
			const grepResult = await this.#ripgrepService.grep(workspaceFolderPath, grepParams);
			const grepIndexLines = this.#buildGrepIndexLines(grepResult);
			const snippets = this.#buildSnippets(grepIndexLines);
			this.#logger.debug(`ripgrep for "${grep.pattern}" — before ranking: ${snippets.length} snippets across ${grepResult.paths.size} files`);
			const totalSnippets = snippets.length;
			const totalFiles = grepResult.paths.size;
			const rankedSnippets = await this.#codeSnippetRanker.rank(snippets, searchTerms, 100);
			const response = this.#formatSnippets(rankedSnippets.map(([s]) => s), totalSnippets, totalFiles);
			const fileCount = new Set(rankedSnippets.map(([s]) => s.path)).size;
			this.#logger.debug(`ripgrep for "${grep.pattern}" — after ranking: ${rankedSnippets.length} snippets across ${fileCount} files`);
			return {
				response,
				error: ""
			};
		} catch (error) {
			this.#logger.error("ripgrep command execution error", error instanceof Error ? error : void 0);
			return {
				response: "",
				error: `${error instanceof Error ? error.message : error}`
			};
		}
	}
	#buildGrepIndexLines(result) {
		const seenLines = /* @__PURE__ */ new Set();
		const matchesPerFile = /* @__PURE__ */ new Map();
		for (const matches of Object.values(result.results)) for (const match of matches) {
			const indexKey = `${match.path}:${match.line}`;
			if (!seenLines.has(indexKey)) {
				seenLines.add(indexKey);
				const lines = matchesPerFile.get(match.path) ?? [];
				lines.push(match);
				matchesPerFile.set(match.path, lines);
			}
		}
		return matchesPerFile;
	}
	#buildSnippets(grepMatchesIndex) {
		const snippets = [];
		for (const [filePath, matches] of grepMatchesIndex) {
			matches.sort((a, b) => a.line - b.line);
			const firstMatch = matches[0];
			if (firstMatch) {
				let currentSnippet = {
					path: filePath,
					startLine: firstMatch.line,
					endLine: firstMatch.line,
					lines: [firstMatch.preview]
				};
				for (let i = 1; i < matches.length; i++) {
					const prevMatch = matches[i - 1];
					const currentMatch = matches[i];
					if (prevMatch && currentMatch) if (currentMatch.line - prevMatch.line === 1) {
						currentSnippet.endLine = currentMatch.line;
						currentSnippet.lines.push(currentMatch.preview);
					} else {
						snippets.push(currentSnippet);
						currentSnippet = {
							path: filePath,
							startLine: currentMatch.line,
							endLine: currentMatch.line,
							lines: [currentMatch.preview]
						};
					}
				}
				snippets.push(currentSnippet);
			}
		}
		return snippets;
	}
	#formatSnippets(snippets, totalMatches, totalFiles) {
		if (totalMatches === 0) return "No matches found.\n";
		const limit = snippets.length;
		const truncated = totalMatches > limit;
		const prefix = `Found ${totalMatches} match${totalMatches === 1 ? "" : "es"} across ${totalFiles} ${totalFiles === 1 ? "file" : "files"}${truncated ? ` (showing first ${limit})` : ""}\n`;
		const snippetsFormatted = [];
		for (const snippet of snippets) {
			const metadata = `${snippet.path}:${snippet.startLine}_${snippet.endLine}`;
			let content = snippet.lines.join("\n");
			if (content.length > MAX_SNIPPET_LENGTH) content = `${content.slice(0, MAX_SNIPPET_LENGTH)}... (trimmed)`;
			snippetsFormatted.push(`${metadata}\n${content}`);
		}
		return `${prefix}${`${snippetsFormatted.join("\n")}\n`}${truncated ? `(Results truncated: showing ${limit} of ${totalMatches} matches (${totalMatches - limit} hidden). Consider using a more specific path or pattern.)\n` : ""}`;
	}
	static {
		_initClass2$9();
	}
});
//#endregion
//#region src/executors/node/actions/list_directory.ts
let _initClass$17, _initClass2$8;
function _applyDecs$17(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName$17(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName$17(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey$17(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS$17(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey$17(t) {
	var i = _toPrimitive$17(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$17(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName$17(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS$17(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
const listDirectoryArgsSchema = z.object({ directory: z.string() });
let _ListDirectoryFormatt;
(class {
	static {
		[_ListDirectoryFormatt, _initClass$17] = _applyDecs$17(this, [Injectable(ToolInputFormatter, [])], []).c;
	}
	toolName = "list_dir";
	format(args) {
		const { directory } = listDirectoryArgsSchema.parse(args);
		return {
			tool: "list_dir",
			directory
		};
	}
	static {
		_initClass$17();
	}
});
let _ListDirectoryActionH;
(class {
	static {
		[_ListDirectoryActionH, _initClass2$8] = _applyDecs$17(this, [Injectable(WorkflowActionHandler, [Logger, collection(FileAccessService)])], []).c;
	}
	#logger;
	#fileAccessService;
	constructor(logger, fileAccessServices) {
		this.#logger = withPrefix(logger, "[ListDirectoryActionHandler]");
		this.#fileAccessService = createFallbackService(this.#logger, fileAccessServices);
	}
	name = "list_dir";
	supportsVirtualWorkspace = false;
	canHandle(action) {
		return Boolean(action.listDirectory);
	}
	async execute({ listDirectory }, { workspaceFolderPath }) {
		this.#logger.debug(`Listing contents in directory "${join(workspaceFolderPath, listDirectory.directory)}"`);
		let realDirPath;
		try {
			realDirPath = await assertAccessibleFile(listDirectory.directory, workspaceFolderPath, this.#fileAccessService, this.#logger);
		} catch (error) {
			return {
				error: error instanceof Error ? error.message : `${error}`,
				response: ""
			};
		}
		try {
			const dirEntries = await promises.readdir(realDirPath, { withFileTypes: true });
			const absPaths = dirEntries.map((de) => join(realDirPath, de.name));
			const ignored = new Set(await findIgnoredPaths(realDirPath, absPaths));
			return {
				response: dirEntries.filter((de) => !ignored.has(join(realDirPath, de.name))).map((de) => `${de.name}${de.isDirectory() ? sep : ""}`).join("\n"),
				error: ""
			};
		} catch (error) {
			const errorMsg = `Failed to read directory "${realDirPath}": ${error}`;
			this.#logger.error(errorMsg, error instanceof Error ? error : void 0);
			return {
				error: errorMsg,
				response: ""
			};
		}
	}
	static {
		_initClass2$8();
	}
});
//#endregion
//#region src/executors/node/actions/mkdir.ts
let _initClass$16, _initClass2$7;
function _applyDecs$16(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName$16(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName$16(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey$16(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS$16(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey$16(t) {
	var i = _toPrimitive$16(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$16(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName$16(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS$16(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
const mkdirArgsSchema = z.object({ directory_path: z.string() });
let _MakeDirectoryFormatt;
(class {
	static {
		[_MakeDirectoryFormatt, _initClass$16] = _applyDecs$16(this, [Injectable(ToolInputFormatter, [])], []).c;
	}
	toolName = "mkdir";
	format(args) {
		const { directory_path: path } = mkdirArgsSchema.parse(args);
		return {
			tool: "mkdir",
			path
		};
	}
	static {
		_initClass$16();
	}
});
let _MakeDirectoryActionH;
(class {
	static {
		[_MakeDirectoryActionH, _initClass2$7] = _applyDecs$16(this, [Injectable(WorkflowActionHandler, [Logger, collection(FileAccessService)])], []).c;
	}
	#logger;
	#fileAccessService;
	constructor(logger, fileAccessServices) {
		this.#logger = withPrefix(logger, "[MakeDirectoryActionHandler]");
		this.#fileAccessService = createFallbackService(this.#logger, fileAccessServices);
	}
	name = "mkdir";
	supportsVirtualWorkspace = false;
	canHandle(action) {
		return Boolean(action.mkdir);
	}
	async execute(action, { workspaceFolderPath, abortSignal }) {
		const { directory_path: directoryPath } = action.mkdir;
		const fullDirectoryPath = join(workspaceFolderPath, directoryPath);
		try {
			await assertAccessibleFile(directoryPath, workspaceFolderPath, this.#fileAccessService, this.#logger);
			this.#logger.debug(`Creating directory "${directoryPath}"`);
			abortSignal.throwIfAborted();
			await mkdir(fullDirectoryPath, { recursive: true });
			return {
				response: `Directory created successfully: "${directoryPath}"`,
				error: ""
			};
		} catch (err) {
			const error = err instanceof Error ? err.message : String(err);
			this.#logger.error(`Unable to create directory "${fullDirectoryPath}"`, err);
			return {
				error,
				response: ""
			};
		}
	}
	static {
		_initClass2$7();
	}
});
//#endregion
//#region src/executors/node/actions/workspace_folder_resolver.ts
/**
* Finds the configured workspace folder that contains `absPath`, so an absolute read
* (e.g. an agent skill location) resolves against the skill's own folder rather than
* only the active one. Returns undefined when the path is outside every folder, in
* which case the caller falls back to the trusted-directory reader.
*/
async function findContainingWorkspaceFolder(absPath, workspaceFolders, realPath) {
	const realTarget = await realPath(absPath) || resolve(absPath);
	const match = (await Promise.all(workspaceFolders.filter((wsf) => Boolean(wsf.uri) && isFileSchemeUri(wsf.uri)).map(async (wsf) => {
		const path = workspaceFolderPathFromUri(wsf.uri);
		const realWs = await realPath(path) || resolve(path);
		return {
			path,
			uri: wsf.uri,
			realWs
		};
	}))).find(({ realWs }) => isPathContainedIn(realWs, realTarget));
	return match ? {
		path: match.path,
		uri: match.uri
	} : void 0;
}
//#endregion
//#region src/executors/node/actions/base_file_reader.ts
/** `trusted` = path is outside every workspace folder (use the trusted-directory reader); otherwise the resolved folder + relative path. */
/**
* Base class for file reading action handlers that need to track file state.
*/
var BaseFileReader = class {
	constructor(logger) {
		this.logger = logger;
	}
	/** Resolves an absolute path to its containing workspace folder, or signals it falls outside every folder (caller falls back to the trusted-directory reader). */
	async resolveAbsolutePath(requestedPath, candidateFolders, realPath) {
		const containing = await findContainingWorkspaceFolder(requestedPath, candidateFolders, realPath);
		if (!containing) {
			this.logger.debug(`Absolute path "${requestedPath}" is outside all workspace folders; using trusted-directory reader`);
			return { trusted: true };
		}
		this.logger.debug(`Absolute path "${requestedPath}" resolved to workspace folder "${containing.path}"`);
		return {
			trusted: false,
			wsPath: containing.path,
			wsUri: containing.uri,
			filePath: relative(containing.path, requestedPath)
		};
	}
	updateFileState(content, fileStateTracker, fullFilePath, filePath) {
		try {
			fileStateTracker.recordFileRead(fullFilePath, content);
		} catch (contentUpdateError) {
			this.logger.warn(`Failed to update version cache after reading for "${filePath}"`, contentUpdateError);
		}
	}
};
//#endregion
//#region src/executors/node/actions/utils/file_slicing.ts
const DEFAULT_LIMIT = 2e3;
const MAX_OUTPUT_BYTES = 50 * 1024;
/**
* Slices file content by line offset and limit, applying a byte budget to prevent oversized responses.
*
* @param content - The full file content as a string
* @param offset - 0-based line index to start from (optional, defaults to 0)
* @param limit - Maximum number of lines to return (optional, defaults to DEFAULT_LIMIT)
* @returns A SliceResult with the formatted content and truncation metadata
*/
function sliceFileContent(content, offset, limit) {
	const lines = content.split("\n");
	const totalLines = lines.length;
	const start = offset ?? 0;
	const end = Math.min(start + (limit ?? DEFAULT_LIMIT), totalLines);
	const collected = [];
	let bytes = 0;
	let truncatedByBytes = false;
	let lastIndex = Math.min(start, totalLines - 1);
	for (let i = start; i < end; i++) {
		const line = lines[i];
		const lineBytes = Buffer.byteLength(line, "utf-8") + (collected.length > 0 ? 1 : 0);
		if (bytes + lineBytes > MAX_OUTPUT_BYTES) {
			truncatedByBytes = true;
			break;
		}
		collected.push(line);
		bytes += lineBytes;
		lastIndex = i;
	}
	const truncated = truncatedByBytes || end < totalLines || collected.length < end - start;
	return {
		content: collected.join("\n"),
		truncated,
		totalLines,
		lastLineIndex: lastIndex,
		startOffset: start
	};
}
/**
* Builds a pagination message appended to truncated output, telling the LLM
* how to fetch the next chunk.
*/
function buildPaginationMessage(result) {
	if (!result.truncated) return "";
	const shownFrom = result.startOffset + 1;
	const shownTo = result.lastLineIndex + 1;
	const nextOffset = result.lastLineIndex + 1;
	return `\n\n(Showing lines ${shownFrom}-${shownTo} of ${result.totalLines} total. Use offset=${nextOffset} to continue reading.)`;
}
//#endregion
//#region src/executors/node/actions/trusted_file_reader.ts
async function readTrustedFile(filePath, fileAccessService, fsClient, logger) {
	const log = withPrefix(logger, "[TrustedFileReader]");
	const normalizedPath = resolve(filePath);
	const trustedDirs = getTrustedReadableDirectories().map((dir) => resolve(dir));
	const canonicalTrustedDirs = await Promise.all(trustedDirs.map(async (dir) => await fileAccessService.realPath(dir) || dir));
	const isContainedIn = (dirs, p) => dirs.some((dir) => isPathContainedIn(dir, p));
	if (!isContainedIn(trustedDirs, normalizedPath)) {
		log.warn(`Denied read of untrusted absolute path: "${filePath}"`);
		return { error: `Access denied: "${filePath}" is outside the repository and not in a trusted directory` };
	}
	log.debug(`Reading trusted file "${filePath}"`);
	try {
		const realPath = await fileAccessService.realPath(normalizedPath);
		if (realPath === "") {
			log.debug(`realPath returned empty for "${normalizedPath}"; cannot resolve`);
			return { error: `Cannot resolve path: "${filePath}"` };
		}
		if (!isContainedIn(canonicalTrustedDirs, realPath)) {
			log.warn(`Denied read: "${filePath}" resolves to "${realPath}" which is outside trusted directories`);
			return { error: `Access denied: "${filePath}" resolves to a path outside trusted directories` };
		}
		if (await isBinaryFile(fsPathToUri(realPath), fsClient)) {
			log.debug(`Trusted file is binary, skipping read: "${filePath}"`);
			return { error: `Cannot read file: "${filePath}" is a binary file` };
		}
		const stat = await fsClient.promises.stat(realPath);
		if (stat.size > 20971520) return { error: `File size (${(stat.size / (1024 * 1024)).toFixed(1)} MB) exceeds the 20 MB limit: "${filePath}"` };
		return { content: await fileAccessService.getText(realPath) };
	} catch (error) {
		log.error(`Error reading trusted file "${filePath}"`, error);
		if (error.code === "ENOENT") return { error: `File not found: "${filePath}"` };
		return { error: `Error reading file: ${error instanceof Error ? error.message : String(error)}` };
	}
}
//#endregion
//#region src/executors/node/actions/read_file.ts
let _initClass$15, _initClass2$6;
function _applyDecs$15(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName$15(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName$15(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey$15(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS$15(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey$15(t) {
	var i = _toPrimitive$15(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$15(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName$15(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS$15(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
const readFileArgsSchema = z.object({
	file_path: z.string(),
	offset: z.number().optional(),
	limit: z.number().optional()
});
let _ReadFileFormatter;
(class {
	static {
		[_ReadFileFormatter, _initClass$15] = _applyDecs$15(this, [Injectable(ToolInputFormatter, [])], []).c;
	}
	toolName = "read_file";
	format(args) {
		const { file_path: filepath, offset, limit } = readFileArgsSchema.parse(args);
		return {
			tool: "read_file",
			filepath,
			...offset != null && { offset },
			...limit != null && { limit }
		};
	}
	static {
		_initClass$15();
	}
});
let _ReadFileActionHandle;
(class extends BaseFileReader {
	static {
		[_ReadFileActionHandle, _initClass2$6] = _applyDecs$15(this, [Injectable(WorkflowActionHandler, [
			Logger,
			collection(FileAccessService),
			FsClient,
			ConfigService
		])], [], 0, void 0, BaseFileReader).c;
	}
	#fileAccessService;
	#fsClient;
	#configService;
	constructor(logger, fileAccessServices, fsClient, configService) {
		super(withPrefix(logger, "[ReadFileActionHandler]"));
		this.#fileAccessService = createFallbackService(this.logger, fileAccessServices);
		this.#fsClient = fsClient;
		this.#configService = configService;
	}
	name = "read_file";
	canHandle(action) {
		return Boolean(action.runReadFile);
	}
	async execute({ runReadFile }, { workspaceFolderPath, workspaceFolderUri, fileStateTracker }) {
		const requestedPath = runReadFile.filepath;
		this.logger.debug(`Reading file "${requestedPath}"`);
		let wsPath = workspaceFolderPath;
		let wsUri = workspaceFolderUri;
		let filePath = requestedPath;
		if (isAbsolute(requestedPath)) {
			const resolved = await this.resolveAbsolutePath(requestedPath, [{ uri: workspaceFolderUri }, ...this.#configService.get().workspaceFolders ?? []], (p) => this.#fileAccessService.realPath(p));
			if (resolved.trusted) {
				const trustedRead = await readTrustedFile(requestedPath, this.#fileAccessService, this.#fsClient, this.logger);
				if (trustedRead.error) return {
					response: "",
					error: trustedRead.error
				};
				const sliced = sliceFileContent(trustedRead.content ?? "", runReadFile.offset, runReadFile.limit);
				return {
					response: sliced.content + buildPaginationMessage(sliced),
					error: ""
				};
			}
			wsPath = resolved.wsPath;
			wsUri = resolved.wsUri;
			filePath = resolved.filePath;
		}
		const fullFilePath = join(wsPath, filePath);
		try {
			await assertAccessibleFile(filePath, wsPath, this.#fileAccessService, this.logger, wsUri);
			if (!isVirtualWorkspaceUri(wsUri)) {
				if (await isBinaryFile(fsPathToUri(fullFilePath), this.#fsClient)) {
					this.logger.debug(`File "${filePath}" detected as binary, skipping read`);
					return {
						response: "",
						error: `Cannot read file: "${requestedPath}" is a binary file`
					};
				}
				const stat = await this.#fsClient.promises.stat(fullFilePath);
				if (stat.size > 20971520) return {
					response: "",
					error: `File size (${(stat.size / (1024 * 1024)).toFixed(1)} MB) exceeds the 20 MB limit: "${requestedPath}"`
				};
			}
			const lookupKey = fileLookupKey(wsPath, wsUri, filePath);
			const fileContent = await this.#fileAccessService.getText(lookupKey);
			this.updateFileState(fileContent, fileStateTracker, fullFilePath, filePath);
			const result = sliceFileContent(fileContent, runReadFile.offset, runReadFile.limit);
			return {
				response: result.content + buildPaginationMessage(result),
				error: ""
			};
		} catch (error) {
			this.logger.error(`Error reading file "${fullFilePath}"`, error);
			if (error.code === "ENOENT") return {
				response: "",
				error: `File not found: "${requestedPath}"`
			};
			return {
				response: "",
				error: `Error reading file: ${error instanceof Error ? error.message : String(error)}`
			};
		}
	}
	static {
		_initClass2$6();
	}
});
//#endregion
//#region src/executors/node/actions/read_files.ts
let _initClass$14, _initClass2$5;
function _applyDecs$14(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName$14(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName$14(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey$14(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS$14(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey$14(t) {
	var i = _toPrimitive$14(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$14(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName$14(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS$14(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
const readFilesArgsSchema = z.object({ file_paths: z.array(z.string()) });
let _ReadFilesFormatter;
(class {
	static {
		[_ReadFilesFormatter, _initClass$14] = _applyDecs$14(this, [Injectable(ToolInputFormatter, [])], []).c;
	}
	toolName = "read_files";
	format(args) {
		const { file_paths: filepaths } = readFilesArgsSchema.parse(args);
		return {
			tool: "read_files",
			filepaths
		};
	}
	static {
		_initClass$14();
	}
});
let _ReadFilesActionHandl;
(class extends BaseFileReader {
	static {
		[_ReadFilesActionHandl, _initClass2$5] = _applyDecs$14(this, [Injectable(WorkflowActionHandler, [
			Logger,
			collection(FileAccessService),
			FsClient,
			ConfigService
		])], [], 0, void 0, BaseFileReader).c;
	}
	#fileAccessService;
	#fsClient;
	#configService;
	constructor(logger, fileAccessServices, fsClient, configService) {
		super(withPrefix(logger, "[ReadFilesActionHandler]"));
		this.#fileAccessService = createFallbackService(this.logger, fileAccessServices);
		this.#fsClient = fsClient;
		this.#configService = configService;
	}
	name = "read_files";
	canHandle(action) {
		return Boolean(action.runReadFiles);
	}
	async execute({ runReadFiles }, { workspaceFolderPath, workspaceFolderUri, fileStateTracker }) {
		const filePaths = runReadFiles.filepaths;
		const results = {};
		const candidateFolders = [{ uri: workspaceFolderUri }, ...this.#configService.get().workspaceFolders ?? []];
		await Promise.allSettled(filePaths.map(async (requestedPath) => {
			let wsPath = workspaceFolderPath;
			let wsUri = workspaceFolderUri;
			let filePath = requestedPath;
			if (isAbsolute(requestedPath)) {
				const resolved = await this.resolveAbsolutePath(requestedPath, candidateFolders, (p) => this.#fileAccessService.realPath(p));
				if (resolved.trusted) {
					const trustedRead = await readTrustedFile(requestedPath, this.#fileAccessService, this.#fsClient, this.logger);
					results[requestedPath] = trustedRead.error ? { error: trustedRead.error } : { content: trustedRead.content };
					return;
				}
				wsPath = resolved.wsPath;
				wsUri = resolved.wsUri;
				filePath = resolved.filePath;
			}
			const fullFilePath = join(wsPath, filePath);
			const lookupKey = fileLookupKey(wsPath, wsUri, filePath);
			try {
				await assertAccessibleFile(filePath, wsPath, this.#fileAccessService, this.logger, wsUri);
				if (!isVirtualWorkspaceUri(wsUri) && await isBinaryFile(fsPathToUri(fullFilePath), this.#fsClient)) {
					this.logger.debug(`File "${filePath}" detected as binary, skipping read`);
					results[requestedPath] = { error: `Cannot read file: "${requestedPath}" is a binary file` };
					return;
				}
				const content = await this.#fileAccessService.getText(lookupKey);
				results[requestedPath] = { content };
				this.updateFileState(content, fileStateTracker, fullFilePath, filePath);
				this.logger.debug(`Successfully read file "${filePath}"`);
			} catch (error) {
				this.logger.error(`Error reading file "${fullFilePath}"`, error);
				if (error.code === "ENOENT") {
					results[requestedPath] = { error: `File not found: "${requestedPath}"` };
					return;
				}
				results[requestedPath] = { error: `Error reading file: ${error instanceof Error ? error.message : String(error)}` };
			}
		}));
		return {
			response: JSON.stringify(results),
			error: ""
		};
	}
	static {
		_initClass2$5();
	}
});
//#endregion
//#region src/executors/node/actions/command_timeout_signal.ts
var CommandTimeoutSignal = class {
	#controller;
	#timerId;
	constructor(timeoutSeconds) {
		if (!Number.isFinite(timeoutSeconds) || timeoutSeconds <= 0) throw new Error(`Invalid timeout: ${timeoutSeconds}`);
		this.#controller = new AbortController();
		this.#timerId = setTimeout(() => {
			this.#controller.abort(new Error(commandTimedOutMessage(timeoutSeconds)));
		}, timeoutSeconds * 1e3);
	}
	get signal() {
		return this.#controller.signal;
	}
	clear() {
		clearTimeout(this.#timerId);
	}
};
//#endregion
//#region src/executors/node/actions/run_command.ts
let _initClass$13, _initClass2$4;
function _applyDecs$13(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName$13(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName$13(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey$13(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS$13(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey$13(t) {
	var i = _toPrimitive$13(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$13(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName$13(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS$13(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
const runCommandArgsSchema = z.union([z.object({ command: z.string() }), z.object({
	program: z.string(),
	args: z.string().optional()
})]);
let _RunCommandFormatter;
(class {
	static {
		[_RunCommandFormatter, _initClass$13] = _applyDecs$13(this, [Injectable(ToolInputFormatter, [])], []).c;
	}
	toolName = "run_command";
	format(args) {
		const parsed = runCommandArgsSchema.parse(args);
		if ("command" in parsed) return {
			tool: "run_command",
			command: parsed.command
		};
		return {
			tool: "run_command",
			command: parsed.args ? `${parsed.program} ${parsed.args}` : parsed.program
		};
	}
	static {
		_initClass$13();
	}
});
let _RunCommandActionHand;
(class {
	static {
		[_RunCommandActionHand, _initClass2$4] = _applyDecs$13(this, [Injectable(WorkflowActionHandler, [Logger, collection(WorkflowCommandService)])], []).c;
	}
	#logger;
	#workflowCommandService;
	constructor(logger, commandServices) {
		this.#logger = withPrefix(logger, "[RunCommandActionHandler]");
		this.#workflowCommandService = createFallbackService(this.#logger, commandServices);
	}
	name = "run_command";
	supportsVirtualWorkspace = false;
	canHandle(action) {
		return Boolean(action.runCommand);
	}
	async execute({ runCommand }, { workspaceFolderPath, workflowId, abortSignal }) {
		const { program, flags, arguments: args, timeout } = runCommand;
		this.#logger.debug(`Running command with params: ${JSON.stringify({
			program,
			flags,
			arguments: args,
			timeout
		})}`);
		const commandTimeout = timeout ? new CommandTimeoutSignal(timeout) : void 0;
		if (commandTimeout) {
			this.#logger.debug(`Timeout signal created: command will be aborted after ${timeout}s`);
			commandTimeout.signal.addEventListener("abort", () => {
				this.#logger.debug(`Command "${program}" timed out after ${timeout}s`);
			});
		}
		const signal = commandTimeout && abortSignal ? AbortSignal.any([abortSignal, commandTimeout.signal]) : commandTimeout?.signal ?? abortSignal;
		try {
			const result = await this.#workflowCommandService.runCommand(workflowId, workspaceFolderPath, program, false, [...flags, ...args], signal);
			if (isCommandError(result)) return {
				...result,
				response: ""
			};
			const { output, exitCode } = result;
			this.#logger.debug(`Command "${program}" exited with code ${exitCode} (${output.length} chars)`);
			return {
				response: `Exit code: ${exitCode}\n${output}`,
				error: ""
			};
		} finally {
			commandTimeout?.clear();
		}
	}
	static {
		_initClass2$4();
	}
});
//#endregion
//#region src/executors/node/actions/run_git_command.ts
let _initClass$12, _initClass2$3;
function _applyDecs$12(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName$12(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName$12(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey$12(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS$12(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey$12(t) {
	var i = _toPrimitive$12(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$12(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName$12(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS$12(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
const runGitCommandArgsSchema = z.object({
	command: z.string(),
	args: z.string().optional()
});
let _RunGitCommandFormatt;
(class {
	static {
		[_RunGitCommandFormatt, _initClass$12] = _applyDecs$12(this, [Injectable(ToolInputFormatter, [])], []).c;
	}
	toolName = "run_git_command";
	format(args) {
		const { command, args: commandArgs } = runGitCommandArgsSchema.parse(args);
		return {
			tool: "run_git_command",
			command,
			...commandArgs != null && { commandArgs }
		};
	}
	static {
		_initClass$12();
	}
});
let _RunGitCommandActionH;
(class extends BaseGitCommand {
	static {
		[_RunGitCommandActionH, _initClass2$3] = _applyDecs$12(this, [Injectable(WorkflowActionHandler, [
			Logger,
			ConfigService,
			SecretRedactor
		])], [], 0, void 0, BaseGitCommand).c;
	}
	#configService;
	constructor(logger, configService, secretRedactor) {
		super(withPrefix(logger, "[RunGitCommandActionHandler]"), configService, secretRedactor);
		this.#configService = configService;
	}
	name = "run_git_command";
	supportsVirtualWorkspace = false;
	canHandle(action) {
		return Boolean(action.runGitCommand);
	}
	async execute({ runGitCommand }, { workspaceFolderPath, workflowToken, workflowId, abortSignal }) {
		try {
			const validationResult = validateGitCommand(runGitCommand.command, runGitCommand.arguments);
			if (!validationResult.isValid) throw new Error(validationResult.error);
			const parsedArgs = validationResult.args ?? [];
			const commandArgs = [...parsedArgs, ...this.#buildSessionTrailerArgs(runGitCommand.command, parsedArgs, workflowId, runGitCommand.repository_url, workflowToken)];
			const gitArgs = await this.buildGitArgs(runGitCommand.command, commandArgs, runGitCommand.repository_url, workspaceFolderPath);
			const result = await this.runGitCommand(gitArgs, workspaceFolderPath, workflowToken.gitlab_rails.token, abortSignal);
			this.logger.debug(`Git command "${runGitCommand.command}" exited with code ${result.exitCode} (${result.output.length} chars)`);
			return {
				response: `Exit code: ${result.exitCode}\n${result.output}`,
				error: ""
			};
		} catch (error) {
			this.logger.error("Git command execution error", error);
			return {
				response: "",
				error: `${error instanceof Error ? error.message : error}`
			};
		}
	}
	#buildSessionTrailerArgs(command, args, workflowId, repositoryUrl, workflowToken) {
		if (command !== "commit" || args.includes("--amend")) return [];
		if (!this.#configService.get("duo.sessionTrackingEnabled")) return [];
		const instanceUrl = this.#configService.get("baseUrl") ?? workflowToken.gitlab_rails.base_url;
		const projectPath = parseGitLabRemote(repositoryUrl, instanceUrl)?.namespaceWithPath;
		if (!instanceUrl || !projectPath || !workflowId) return [];
		return [
			"--trailer",
			"Co-authored-by: GitLab Duo <duo@gitlab.com>",
			"--trailer",
			`Duo-Session: ${instanceUrl}/${projectPath}/-/automate/agent-sessions/${workflowId}`
		];
	}
	static {
		_initClass2$3();
	}
});
//#endregion
//#region src/executors/node/actions/run_shell_command.ts
let _initClass$11, _initClass2$2;
function _applyDecs$11(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName$11(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName$11(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey$11(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS$11(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey$11(t) {
	var i = _toPrimitive$11(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$11(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName$11(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS$11(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
const runShellCommandArgsSchema = z.object({ command: z.string() });
let _RunShellCommandForma;
(class {
	static {
		[_RunShellCommandForma, _initClass$11] = _applyDecs$11(this, [Injectable(ToolInputFormatter, [])], []).c;
	}
	toolName = "shell_command";
	format(args) {
		const { command } = runShellCommandArgsSchema.parse(args);
		return {
			tool: "shell_command",
			command
		};
	}
	static {
		_initClass$11();
	}
});
let _RunShellCommandActio;
(class {
	static {
		[_RunShellCommandActio, _initClass2$2] = _applyDecs$11(this, [Injectable(WorkflowActionHandler, [Logger, collection(WorkflowCommandService)])], []).c;
	}
	#logger;
	#workflowCommandService;
	constructor(logger, commandServices) {
		this.#logger = withPrefix(logger, "[RunShellCommandActionHandler]");
		this.#workflowCommandService = createFallbackService(this.#logger, commandServices);
	}
	name = "shell_command";
	supportsVirtualWorkspace = false;
	canHandle(action) {
		return Boolean(action.runShellCommand);
	}
	async execute({ runShellCommand }, { workspaceFolderPath, workflowId, abortSignal }) {
		const { command, timeout } = runShellCommand;
		this.#logger.debug(`Running shell command: "${command}"${timeout ? ` with timeout of ${timeout}s` : ""}`);
		const commandTimeout = timeout ? new CommandTimeoutSignal(timeout) : void 0;
		if (commandTimeout) {
			this.#logger.debug(`Timeout signal created: command will be aborted after ${timeout}s`);
			commandTimeout.signal.addEventListener("abort", () => {
				this.#logger.debug(`Shell command timed out after ${timeout}s`);
			});
		}
		const signal = commandTimeout && abortSignal ? AbortSignal.any([abortSignal, commandTimeout.signal]) : commandTimeout?.signal ?? abortSignal;
		try {
			const result = await this.#workflowCommandService.runShellCommand(workflowId, workspaceFolderPath, command, false, signal);
			if (isCommandError(result)) return {
				...result,
				response: ""
			};
			const { output, exitCode } = result;
			this.#logger.debug(`Shell command exited with code ${exitCode} (${output.length} chars)`);
			return {
				response: `Exit code: ${exitCode}\n${output}`,
				error: ""
			};
		} finally {
			commandTimeout?.clear();
		}
	}
	static {
		_initClass2$2();
	}
});
//#endregion
//#region src/executors/node/actions/run_mcp_tool.ts
let _initClass$10;
function _applyDecs$10(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName$10(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName$10(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey$10(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS$10(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey$10(t) {
	var i = _toPrimitive$10(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$10(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName$10(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS$10(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
let _RunMcpToolActionHand;
(class {
	static {
		[_RunMcpToolActionHand, _initClass$10] = _applyDecs$10(this, [Service({
			dependencies: [
				Logger,
				McpManagerWorkflowExecutorAdaptor,
				SandboxViolations
			],
			lifetime: ServiceLifetime.Singleton
		}), Implements(WorkflowActionHandler)], []).c;
	}
	#logger;
	#mcpManager;
	#sandboxViolations;
	constructor(logger, mcpManager, sandboxViolations) {
		this.#logger = withPrefix(logger, "[RunMcpToolActionHandler]");
		this.#mcpManager = mcpManager;
		this.#sandboxViolations = sandboxViolations;
	}
	name = "run_mcp_tool";
	canHandle(action) {
		return Boolean(action.runMCPTool);
	}
	async execute({ runMCPTool }, { abortSignal }) {
		const startMs = Date.now();
		try {
			const { name, args } = runMCPTool;
			this.#logger.debug(`Running MCP tool: "${name}" with args: "${args}"`);
			abortSignal.throwIfAborted();
			const response = await this.#mcpManager.execute(name, args);
			if (response.startsWith(MCP_TOOL_FAILURE_PREFIX)) {
				const sandboxError = this.#renderViolation(startMs, response);
				if (sandboxError) return {
					error: sandboxError,
					response: ""
				};
			}
			return {
				response,
				error: ""
			};
		} catch (err) {
			const original = `${err instanceof Error ? err.message : err}`;
			return {
				error: this.#renderViolation(startMs, original) ?? original,
				response: ""
			};
		}
	}
	#renderViolation(startMs, errorText) {
		return renderViolation(this.#sandboxViolations, startMs, errorText, this.#logger);
	}
	static {
		_initClass$10();
	}
});
//#endregion
//#region src/executors/node/wake_scheduler.ts
/**
* A wake accepted from a `scheduleNotification` action: when `deadline` passes,
* `message` is delivered back into the session identified by `workflowId`.
* `taskId` is assigned by the server per session, so `(workflowId, taskId)` — not
* `taskId` alone — identifies a wake.
*/
/** Arms local timers for `scheduleNotification` actions; the embedding application binds the implementation. */
const WakeScheduler = createInterfaceId("WakeScheduler");
//#endregion
//#region src/executors/node/actions/notification_condition.ts
const timerConditionSchema = z.object({
	type: z.literal("timer"),
	deadline: z.iso.datetime({ offset: true })
});
function parseNotificationCondition(condition, now) {
	let raw;
	try {
		raw = JSON.parse(condition);
	} catch {
		return {
			ok: false,
			reason: `notification condition is not valid JSON: ${condition}`
		};
	}
	const parsed = timerConditionSchema.safeParse(raw);
	if (!parsed.success) return {
		ok: false,
		reason: `notification condition must be a "timer" with an RFC3339 "deadline" with timezone (e.g. {"type":"timer","deadline":"2026-01-01T10:00:00Z"}): ${parsed.error.issues.map((i) => i.message).join("; ")}`
	};
	const deadline = new Date(parsed.data.deadline);
	if (deadline.getTime() <= now.getTime()) return {
		ok: false,
		reason: `deadline ${parsed.data.deadline} is not in the future`
	};
	return {
		ok: true,
		deadline
	};
}
//#endregion
//#region src/executors/node/actions/schedule_notification.ts
let _initClass$9, _initClass2$1;
function _applyDecs$9(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName$9(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName$9(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey$9(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS$9(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey$9(t) {
	var i = _toPrimitive$9(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$9(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName$9(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS$9(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
/**
* A refusal reason quotes untrusted input (a malformed condition, a task id) and
* rides the ack, which — unlike a plain-text or HTTP response — is not size-checked
* against MAX_MESSAGE_SIZE before it goes on the wire. It is model-facing prose, so
* a generous bound costs nothing and keeps the ack from ever being the oversized one.
*/
const MAX_REFUSAL_REASON_BYTES = 1024;
const notifyMeWhenArgsSchema = z.object({ when: z.object({
	type: z.string().optional(),
	delay_minutes: z.number()
}) });
let _NotifyMeWhenFormatte;
(class {
	static {
		[_NotifyMeWhenFormatte, _initClass$9] = _applyDecs$9(this, [Injectable(ToolInputFormatter, [])], []).c;
	}
	toolName = "notify_me_when";
	format(args) {
		return {
			tool: "notify_me_when",
			delayMinutes: notifyMeWhenArgsSchema.parse(args).when.delay_minutes
		};
	}
	static {
		_initClass$9();
	}
});
let _ScheduleNotification;
(class {
	static {
		[_ScheduleNotification, _initClass2$1] = _applyDecs$9(this, [Injectable(WorkflowActionHandler, [Logger, collection(WakeScheduler)])], []).c;
	}
	#logger;
	#scheduler;
	constructor(logger, schedulers) {
		this.#logger = withPrefix(logger, "[ScheduleNotificationActionHandler]");
		[this.#scheduler] = schedulers;
	}
	name = "schedule_notification";
	supportsVirtualWorkspace = true;
	canHandle(action) {
		return Boolean(action.scheduleNotification);
	}
	async execute({ scheduleNotification }, { workflowId }) {
		const taskId = scheduleNotification.task_id;
		if (!taskId) return this.#refuse("notification is missing a task_id");
		const parsed = parseNotificationCondition(scheduleNotification.condition ?? "", /* @__PURE__ */ new Date());
		if (!parsed.ok) return this.#refuse(parsed.reason);
		if (!this.#scheduler) return this.#refuse("this client cannot schedule notifications");
		const result = this.#scheduler.schedule({
			workflowId,
			taskId,
			deadline: parsed.deadline,
			message: scheduleNotification.message ?? ""
		});
		if (!result.scheduled) return this.#refuse(result.reason);
		this.#logger.info(`Accepted notification ${taskId} for workflow ${workflowId}, deadline ${parsed.deadline.toISOString()}`);
		return {
			accepted: true,
			reason: "",
			fires_at: parsed.deadline.toISOString()
		};
	}
	#refuse(reason) {
		this.#logger.info(`Refusing scheduleNotification: ${reason}`);
		return {
			accepted: false,
			reason: truncateToByteLimit(reason, MAX_REFUSAL_REASON_BYTES, { suffix: "[truncated]" }),
			fires_at: ""
		};
	}
	static {
		_initClass2$1();
	}
});
//#endregion
//#region src/executors/node/actions/write_file.ts
let _initClass$8, _initClass2;
function _applyDecs$8(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName$8(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName$8(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey$8(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS$8(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey$8(t) {
	var i = _toPrimitive$8(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$8(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName$8(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS$8(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
const writeFileArgsSchema = z.object({
	file_path: z.string(),
	contents: z.string()
});
let _WriteFileFormatter;
(class {
	static {
		[_WriteFileFormatter, _initClass$8] = _applyDecs$8(this, [Injectable(ToolInputFormatter, [])], []).c;
	}
	toolName = "create_file_with_contents";
	format(args) {
		const { file_path: filepath, contents } = writeFileArgsSchema.parse(args);
		return {
			tool: "create_file_with_contents",
			filepath,
			content: contents
		};
	}
	static {
		_initClass$8();
	}
});
let _WriteFileActionHandl;
(class {
	static {
		[_WriteFileActionHandl, _initClass2] = _applyDecs$8(this, [Injectable(WorkflowActionHandler, [Logger, collection(FileAccessService)])], []).c;
	}
	#logger;
	#fileAccessService;
	constructor(logger, fileAccessServices) {
		this.#logger = withPrefix(logger, "[WriteFileActionHandler]");
		this.#fileAccessService = createFallbackService(this.#logger, fileAccessServices);
	}
	name = "create_file_with_contents";
	canHandle(action) {
		return Boolean(action.runWriteFile);
	}
	async execute({ runWriteFile }, { workspaceFolderPath, workspaceFolderUri, fileStateTracker, abortSignal }) {
		const filePath = runWriteFile.filepath;
		const fullFilePath = join(workspaceFolderPath, filePath);
		const lookupKey = fileLookupKey(workspaceFolderPath, workspaceFolderUri, filePath);
		try {
			await this.#fileAccessService.getText(lookupKey);
			const errorMessage = `File "${filePath}" already exists. Use the edit_file tool to modify existing files.`;
			this.#logger.debug(errorMessage);
			return {
				error: errorMessage,
				response: ""
			};
		} catch (error) {
			if (!(error instanceof FileNotFoundError)) {
				this.#logger.error(`Failed to check if file exists for: "${filePath}"`, error);
				throw error;
			}
		}
		try {
			await assertAccessibleFile(filePath, workspaceFolderPath, this.#fileAccessService, this.#logger, workspaceFolderUri);
			this.#logger.debug(`Writing file "${filePath}"`);
			abortSignal.throwIfAborted();
			await this.#fileAccessService.writeFile(lookupKey, runWriteFile.contents);
			await this.#updateFileState(fileStateTracker, fullFilePath, filePath, lookupKey);
			return {
				response: "File written successfully",
				error: ""
			};
		} catch (err) {
			const error = err instanceof Error ? err.message : String(err);
			this.#logger.error(`Error writing file "${fullFilePath}"`, err);
			return {
				error,
				response: ""
			};
		}
	}
	/**
	* Update our file state tracker now that the file has been edited, so that Duo does not need to
	* re-read the file for subsequent edits since it knows the current edited state.
	*/
	async #updateFileState(fileStateTracker, fullFilePath, filePath, lookupKey) {
		try {
			const updatedContent = await this.#fileAccessService.getText(lookupKey);
			fileStateTracker.recordFileRead(fullFilePath, updatedContent);
		} catch (contentUpdateError) {
			this.#logger.warn(`Failed to update version cache after edit for "${filePath}"`, contentUpdateError);
		}
	}
	static {
		_initClass2();
	}
});
//#endregion
//#region src/contributions.ts
const workflowExecutorContributions = [
	_BM25CodeSnippetsRank,
	_DefaultModelResolver,
	_DefaultNodeExecutor,
	_DefaultNodeExecutorW,
	_DefaultWorkflowConne,
	_DefaultWorkflowGraph,
	_DefaultWorkflowRails,
	_DefaultWorkflowToken,
	_EditFileActionHandle,
	_FindFilesActionHandl,
	_GitlabApiRequestActi,
	_GrepActionHandler,
	_ListDirectoryActionH,
	_MakeDirectoryActionH,
	_ReadFileActionHandle,
	_ReadFilesActionHandl,
	_RunCommandActionHand,
	_RunGitCommandActionH,
	_RunMcpToolActionHand,
	_RunShellCommandActio,
	_ScheduleNotification,
	_WriteFileActionHandl,
	_DefaultFileStateTrac,
	_DefaultRipgrepServic
];
//#endregion
//#region src/desktop_workflow_runner.ts
let _initClass$7;
function _applyDecs$7(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName$7(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName$7(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey$7(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS$7(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey$7(t) {
	var i = _toPrimitive$7(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$7(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName$7(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS$7(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
let _DesktopWorkflowRunne;
(class {
	static {
		[_DesktopWorkflowRunne, _initClass$7] = _applyDecs$7(this, [Injectable(WorkflowRunner, [
			ConfigService,
			Logger,
			WorkflowRailsService,
			WorkflowTokenService,
			ExecutorManager,
			ModelResolverService,
			UserService
		])], []).c;
	}
	#workspaceFolders;
	#projectPath;
	#defaultNamespacePath;
	#executorManager;
	#prefixedLogger;
	#logger;
	#workflowRailsService;
	#workflowTokenService;
	#aiFlowsMetadataCache = /* @__PURE__ */ new Map();
	#modelResolverService;
	#userService;
	#userPreferencesDefaultNamespacePath;
	constructor(configService, logger, workflowRailsService, workflowTokenService, executorManager, modelResolverService, userService) {
		this.#logger = logger;
		this.#prefixedLogger = withPrefix(logger, "[Duo Workflow Runner]");
		this.#workflowRailsService = workflowRailsService;
		this.#workflowTokenService = workflowTokenService;
		this.#executorManager = executorManager;
		this.#modelResolverService = modelResolverService;
		this.#userService = userService;
		const initialConfig = configService.get();
		this.#reconfigure(initialConfig);
		configService.onConfigChange((config) => this.#reconfigure(config));
		doNotAwait(this.#initializeUserDefaultNamespace());
	}
	async #initializeUserDefaultNamespace() {
		try {
			const user = await this.#userService.getUser();
			this.#userPreferencesDefaultNamespacePath = user.duoDefaultNamespacePath;
		} catch (error) {
			this.#logger.debug("Failed to initialize user default namespace", error);
		}
	}
	#reconfigure(config) {
		this.#workspaceFolders = config.workspaceFolders || [];
		this.#projectPath = config.projectPath || void 0;
		this.#defaultNamespacePath = config.duo?.agentPlatform?.defaultNamespace;
	}
	#getEffectiveNamespacePath() {
		if (this.#userPreferencesDefaultNamespacePath) return this.#userPreferencesDefaultNamespacePath;
		if (this.#defaultNamespacePath) this.#logger.debug(`Config userPreferencesDefaultNamespacePath is empty, using IDE defaultNamespacePath: ${this.#defaultNamespacePath}`);
		return this.#defaultNamespacePath;
	}
	getProjectPath() {
		return this.#projectPath || "";
	}
	getNamespacePath() {
		return this.#getEffectiveNamespacePath() || "";
	}
	getServerCapabilities(workflowId, workflowDefinition) {
		return this.#workflowTokenService.getServerCapabilities({
			workflowDefinition,
			workflowId
		});
	}
	/**
	* Fetches (and caches per namespace/project scope) the `aiFlowsMetadata`
	* query response, shared by getDefaultFlow() and
	* getServerCapabilitiesFromMetadata(). A rejected fetch is evicted from the
	* cache so the next call retries instead of latching onto a failure.
	*
	* `rootNamespaceId` is a plain numeric/string ID (converted to a `NamespaceID`
	* GID internally). `projectId`, however, must already be a full `ProjectID` GID
	* (e.g. `gid://gitlab/Project/123`) — it is NOT converted here. Do not pass a
	* project path or plain numeric ID; use `toGitLabGid(GID_NAMESPACE_PROJECT, id)`
	* first, otherwise the GraphQL request fails with an invalid variable value.
	*/
	#getAiFlowsMetadata(rootNamespaceId, projectId) {
		const cacheKey = `${rootNamespaceId ?? ""}|${projectId ?? ""}`;
		const cached = this.#aiFlowsMetadataCache.get(cacheKey);
		if (cached) return cached;
		const variables = {};
		if (rootNamespaceId) variables.namespaceId = toGitLabGid(GID_NAMESPACE_GROUP, rootNamespaceId);
		if (projectId) variables.projectId = projectId;
		const promise = this.#workflowRailsService.getGraphqlData({
			operationName: "aiFlowsMetadata",
			query: null,
			variables
		}).catch((error) => {
			this.#aiFlowsMetadataCache.delete(cacheKey);
			throw error;
		});
		this.#aiFlowsMetadataCache.set(cacheKey, promise);
		return promise;
	}
	/**
	* @param projectId Must already be a `ProjectID` GID (e.g. `gid://gitlab/Project/123`), not a
	* path or plain numeric ID — see `#getAiFlowsMetadata`.
	*/
	async getDefaultFlow(rootNamespaceId, projectId) {
		try {
			const metadata = (await this.#getAiFlowsMetadata(rootNamespaceId, projectId)).aiFlowsMetadata?.capabilities.find((capability) => capability.name === "duo_developer")?.metadata;
			if (!metadata) return null;
			return defaultFlowConfigSchema.parse(metadata);
		} catch (error) {
			this.#prefixedLogger.warn("Failed to read default flow from aiFlowsMetadata", error);
			return null;
		}
	}
	/**
	* Server capabilities read from the `aiFlowsMetadata` query, decoupled from
	* workflow-token creation (i.e. no `direct_access` request required). This
	* mirrors (and is intended to eventually replace) the token-derived
	* `getServerCapabilities()`, which requires a workflow to already have a
	* cached token. Returns `null` when the instance doesn't advertise
	* `aiFlowsMetadata` (<19.2) or the query failed — callers should fall back
	* to `getServerCapabilities()` in that case.
	*
	* @param projectId Must already be a `ProjectID` GID (e.g. `gid://gitlab/Project/123`), not a
	* path or plain numeric ID — see `#getAiFlowsMetadata`.
	*/
	async getServerCapabilitiesFromMetadata(rootNamespaceId, projectId) {
		try {
			return (await this.#getAiFlowsMetadata(rootNamespaceId, projectId)).aiFlowsMetadata?.capabilities.map((capability) => capability.name) ?? null;
		} catch (error) {
			this.#prefixedLogger.warn("Failed to read server capabilities from aiFlowsMetadata", error);
			return null;
		}
	}
	async preCreateWorkflow(draftGoal, workflowDefinition, aiCatalogItemVersionId, metadata, additionalOptions) {
		if (!this.#workspaceFolders || this.#workspaceFolders.length === 0) throw new Error("No workspace folders");
		this.#logger.debug("Optimistically pre-creating workflow...");
		const workflowId = await this.#createWorkflow(draftGoal, workflowDefinition, aiCatalogItemVersionId, metadata, additionalOptions);
		this.#logger.debug(`Workflow "${workflowId}" + auth token pre-created, ready for the user to submit their prompt.`);
		return workflowId;
	}
	async createWorkflow(goal, workflowDefinition, aiCatalogItemVersionId, metadata, additionalOptions) {
		const effectiveProjectPath = metadata?.projectPath || this.#projectPath;
		const effectiveNamespacePath = effectiveProjectPath ? void 0 : this.#getEffectiveNamespacePath();
		return this.#workflowRailsService.createWorkflow(goal, {
			project_id: effectiveProjectPath,
			namespace_id: effectiveNamespacePath
		}, workflowDefinition, aiCatalogItemVersionId ? tryParseGitLabGid(aiCatalogItemVersionId) : void 0, additionalOptions);
	}
	async *runWorkflow(payload) {
		if (!this.#workspaceFolders?.length) throw new Error("No workspace folders");
		const selectedWorkspaceFolder = this.#workspaceFolders.find((f) => {
			if (isFileSchemeUri(f.uri)) return workspaceFolderPathFromUri(f.uri) === payload.metadata?.rootFsPath;
			return f.uri === payload.metadata?.rootFsPath;
		}) ?? this.#workspaceFolders[0];
		const workspaceFolderPath = workspaceFolderPathFromUri(selectedWorkspaceFolder.uri);
		if (this.#workspaceFolders.length > 1) this.#prefixedLogger.info(`More than one workspace folder detected. Using workspace folder ${workspaceFolderPath}`);
		const { goal, existingWorkflowId, preCreatedWorkflowId, workflowDefinition, aiCatalogItemVersionId, metadata, additionalOptions } = payload;
		let workflowId = existingWorkflowId || preCreatedWorkflowId;
		if (!workflowId) workflowId = await this.#createWorkflow(goal, workflowDefinition, aiCatalogItemVersionId, metadata, additionalOptions);
		const executor = this.#executorManager.getExecutorForWorkflow(workflowId);
		const runOptions = {
			...payload,
			workspaceFolderPath,
			workspaceFolderUri: selectedWorkspaceFolder.uri,
			workflowId
		};
		try {
			this.#executorManager.clearExecutorDisposal(workflowId);
			yield* executor.runWorkflow(runOptions);
		} finally {
			this.#executorManager.setupExecutorDisposal(workflowId);
		}
	}
	stopWorkflow(workflowId) {
		const executor = this.#executorManager.getExecutorForWorkflow(workflowId);
		if (executor) executor.stopWorkflow();
	}
	interruptRunningCommand(workflowId) {
		const executor = this.#executorManager.getExecutorForWorkflow(workflowId);
		if (executor) executor.interruptRunningCommand();
	}
	isCommandRunning(workflowId) {
		return this.#executorManager.getExecutorForWorkflow(workflowId)?.isCommandRunning() ?? false;
	}
	async getGraphqlData(payload) {
		return this.#workflowRailsService.getGraphqlData(payload);
	}
	async updateStatus(statusUpdate) {
		return this.#workflowRailsService.updateStatus(statusUpdate);
	}
	async updateAgentPrivileges(workflowId, agentPrivileges, preApprovedAgentPrivileges) {
		return (await this.#workflowRailsService.getGraphqlData({
			operationName: "updateAgentPrivileges",
			query: null,
			variables: {
				workflowId: generateGraphqlWorkflowId(workflowId),
				agentPrivileges,
				preApprovedAgentPrivileges
			}
		})).updateDuoWorkflowAgentPrivileges.errors ?? [];
	}
	async sendEvent(workflowID, eventType, message) {
		return this.#workflowRailsService.sendEvent(workflowID, eventType, message);
	}
	async resolveModel(requestedModel, rootNamespaceId) {
		return this.#modelResolverService.resolveModel(requestedModel, rootNamespaceId);
	}
	async #createWorkflow(goal, workflowDefinition, aiCatalogItemVersionId, metadata, additionalOptions) {
		const resolvedWorkflowDefinition = resolveWorkflowDefinition(workflowDefinition);
		const effectiveProjectPath = metadata?.projectPath || this.#projectPath;
		const effectiveNamespacePath = effectiveProjectPath ? void 0 : this.#getEffectiveNamespacePath();
		const rootNamespaceId = metadata?.rootNamespaceId;
		const projectId = metadata?.projectId;
		let projectGid;
		if (projectId) projectGid = projectId.startsWith("gid://") ? projectId : toGitLabGid(GID_NAMESPACE_PROJECT, projectId);
		const createWorkflowPromise = this.#workflowRailsService.createWorkflow(goal, {
			project_id: effectiveProjectPath,
			namespace_id: effectiveNamespacePath
		}, resolvedWorkflowDefinition, aiCatalogItemVersionId ? tryParseGitLabGid(aiCatalogItemVersionId) : void 0, additionalOptions);
		const metadataCapabilities = await this.getServerCapabilitiesFromMetadata(rootNamespaceId, projectGid);
		const tokenPromise = metadataCapabilities !== null ? Promise.resolve(this.#workflowRailsService.buildAmbientWorkflowToken(metadataCapabilities)) : this.#workflowRailsService.getWorkflowToken(resolvedWorkflowDefinition, rootNamespaceId, effectiveProjectPath).catch((error) => {
			if (error instanceof InvalidInstanceVersionError) {
				this.#prefixedLogger.debug("direct_access token not available (instance version too old)", error);
				return null;
			}
			throw error;
		});
		const [createdWorkflowId, token] = await Promise.all([createWorkflowPromise, tokenPromise]);
		if (token) this.#workflowTokenService.cacheToken(createdWorkflowId, resolvedWorkflowDefinition, token);
		return createdWorkflowId;
	}
	static {
		_initClass$7();
	}
});
//#endregion
//#region src/services/run_command_as_process.ts
let _initClass$6;
function _applyDecs$6(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName$6(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName$6(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey$6(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS$6(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey$6(t) {
	var i = _toPrimitive$6(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$6(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName$6(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS$6(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
let _RunCommandAsProcess;
(class {
	static {
		[_RunCommandAsProcess, _initClass$6] = _applyDecs$6(this, [Injectable(WorkflowCommandService, [Logger, ConfigService])], []).c;
	}
	#logger;
	#configService;
	constructor(logger, configService) {
		this.#logger = withPrefix(logger, "[RunCommandAsProcess]");
		this.#configService = configService;
	}
	priority = 1;
	/**
	* Creates a filtered environment object excluding sensitive variables for process execution
	*/
	#createFilteredEnv(sourceEnv = process.env) {
		const excludedVars = [
			"CI_JOB_TOKEN",
			"GITLAB_OAUTH_TOKEN",
			"DUO_WORKFLOW_SERVICE_TOKEN"
		];
		const filtered = {};
		for (const [key, value] of Object.entries(sourceEnv)) if (!excludedVars.includes(key)) filtered[key] = value;
		if (!filtered.AI_AGENT) try {
			const lsVersion = getLanguageServerVersion();
			const sanitized = (this.#configService.get("clientInfo")?.name)?.toLowerCase().replace(/[^a-z0-9._-]/g, "-");
			filtered.AI_AGENT = sanitized ? `gitlab-lsp_${lsVersion}__${sanitized}` : `gitlab-lsp_${lsVersion}`;
		} catch {
			this.#logger.debug("Could not determine language server version for AI_AGENT env var");
		}
		return filtered;
	}
	/**
	* Executes a command directly as a child process without shell interpretation.
	* Arguments are passed separately to avoid shell injection vulnerabilities.
	*/
	async runCommand(workflowId, workspaceFolderPath, command, _silent, args, abortSignal = new AbortController().signal) {
		this.#logger.debug(`Running command: ${command} ${args.join(" ")} in ${workspaceFolderPath} for workflowId: ${workflowId}`);
		return this.#spawnCommand(command, args, {
			cwd: workspaceFolderPath,
			signal: abortSignal,
			shell: false
		});
	}
	/**
	* Executes a command string through the system shell, enabling shell features
	* like pipes, redirects, and command chaining (e.g., `&&`, `|`).
	*/
	async runShellCommand(workflowId, workspaceFolderPath, command, _silent, abortSignal = new AbortController().signal) {
		this.#logger.debug(`Running shell command: ${command} in ${workspaceFolderPath} for workflowId: ${workflowId}`);
		return this.#spawnCommand(command, [], {
			cwd: workspaceFolderPath,
			signal: abortSignal,
			shell: true
		});
	}
	/**
	* Spawns a child process with the given command and options.
	* Captures stdout/stderr and handles abort signals.
	*/
	#spawnCommand(command, args, options) {
		const { signal, ...spawnOptions } = options;
		return new Promise((resolve) => {
			const child = spawn(command, args, {
				...spawnOptions,
				env: this.#createFilteredEnv()
			});
			let output = "";
			let resolved = false;
			const resolveOnce = (result) => {
				if (!resolved) {
					resolved = true;
					signal?.removeEventListener("abort", abortHandler);
					resolve(result);
				}
			};
			const abortHandler = () => {
				const reason = signal?.reason;
				const isUserInterrupt = reason instanceof Error && reason.message === "Command was interrupted by the user";
				const isTimeout = reason instanceof Error && isCommandTimedOut(reason.message);
				child.kill("SIGTERM");
				if (isUserInterrupt) {
					this.#logger.info("Command interrupted by user");
					resolveOnce({ error: `${USER_INTERRUPTED_COMMAND}${output.length > 0 ? `\nPartial output:\n${output}` : ""}` });
				} else if (isTimeout) {
					this.#logger.info("Command timed out");
					const partialOutput = output.length > 0 ? `\nPartial output:\n${output}` : "";
					resolveOnce({ error: `${reason.message}${partialOutput}` });
				} else {
					this.#logger.info("Command aborted due to signal");
					resolveOnce({ error: "Operation was aborted because the workflow was cancelled or stopped" });
				}
			};
			child.stdout?.on("data", (data) => {
				output += data;
			});
			child.stderr?.on("data", (data) => {
				output += data;
			});
			child.on("error", (error) => {
				this.#logger.error(`Command execution error: ${error.message}`);
				resolveOnce({ error: error.message });
			});
			child.on("close", (exitCode) => {
				this.#logger.debug(`Command exited with code ${exitCode} (${output.length} chars)`);
				resolveOnce({
					output,
					exitCode
				});
			});
			if (signal?.aborted) {
				abortHandler();
				return;
			}
			signal?.addEventListener("abort", abortHandler);
		});
	}
	static {
		_initClass$6();
	}
});
//#endregion
//#region src/services/default_rg_binary_provider.ts
let _initClass$5;
function _applyDecs$5(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName$5(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName$5(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey$5(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS$5(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey$5(t) {
	var i = _toPrimitive$5(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$5(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName$5(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS$5(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
let _DefaultRgBinaryProvi;
(class {
	static {
		[_DefaultRgBinaryProvi, _initClass$5] = _applyDecs$5(this, [Service({
			dependencies: [Logger, RgEmbeddedBinaryPath],
			lifetime: ServiceLifetime.Singleton
		}), Implements(RgBinaryProvider)], []).c;
	}
	#logger;
	#embeddedPath;
	#extractedPath = null;
	constructor(logger, embeddedPath) {
		this.#logger = withPrefix(logger, "[RgBinaryProvider]");
		this.#embeddedPath = embeddedPath;
	}
	/**
	* `GITLAB_BIN_DIR` redirects extraction away from the OS temp directory, for environments where
	* policy (AppLocker/EDR/DLP) blocks executing binaries from temp. It is set fleet-wide by
	* administrators, so there is no flag or client setting for it.
	*/
	#resolveBaseDir() {
		return this.#normalizeBinaryDir(process.env.GITLAB_BIN_DIR) ?? tmpdir();
	}
	/**
	* A relative directory is rejected rather than resolved: the client owns this process' working
	* directory, so it would put the binary somewhere the user did not ask for. Unusable values
	* fall back to the OS temp directory.
	*/
	#normalizeBinaryDir(binaryDir) {
		const unquoted = binaryDir?.trim().replace(/^(["'])(.*)\1$/, "$2").trim();
		if (!unquoted) return;
		const expanded = expandHomeDir(unquoted);
		if (!isAbsolute(expanded)) {
			this.#logger.warn(`Ignoring GITLAB_BIN_DIR "${binaryDir}": expected an absolute path, falling back to the OS temporary directory`);
			return;
		}
		return expanded;
	}
	async getPath() {
		if (this.#extractedPath) return this.#extractedPath;
		const baseDir = this.#resolveBaseDir();
		try {
			this.#extractedPath = await this.#extractBinary(baseDir);
			return this.#extractedPath;
		} catch (error) {
			this.#logger.error(`Failed to extract ripgrep binary into "${baseDir}"`, error instanceof Error ? error : new Error(String(error)));
			return null;
		}
	}
	async #extractBinary(baseDir) {
		const binaryData = readFileSync(this.#embeddedPath);
		const hash = createHash("sha256").update(binaryData).digest("hex").slice(0, 8);
		const binaryName = process.platform === "win32" ? "rg.exe" : "rg";
		const extractDir = join(baseDir, "gitlab-duo-cli", "bin", hash);
		const extractedPath = join(extractDir, binaryName);
		if (existsSync(extractedPath)) {
			this.#logger.info(`rg already extracted at ${extractedPath}`);
			return extractedPath;
		}
		mkdirSync(extractDir, { recursive: true });
		const tmpPath = `${extractedPath}.tmp.${process.pid}`;
		writeFileSync(tmpPath, binaryData);
		if (process.platform !== "win32") chmodSync(tmpPath, 493);
		renameSync(tmpPath, extractedPath);
		this.#logger.info(`rg extracted to ${extractedPath}`);
		return extractedPath;
	}
	static {
		_initClass$5();
	}
});
//#endregion
//#region src/executors/default_action_executor_factory.ts
let _initClass$4;
function _applyDecs$4(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName$4(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName$4(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey$4(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS$4(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey$4(t) {
	var i = _toPrimitive$4(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$4(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName$4(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS$4(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
let _DefaultActionExecuto;
(class {
	static {
		[_DefaultActionExecuto, _initClass$4] = _applyDecs$4(this, [Injectable(ActionExecutorFactory, [Logger, collection(WorkflowActionHandler)])], []).c;
	}
	#logger;
	#handlers;
	constructor(logger, handlers) {
		this.#logger = withPrefix(logger, "[ActionExecutorFactory]");
		this.#handlers = handlers;
	}
	createExecutor() {
		this.#logger.debug("Creating DirectActionExecutor");
		return new DirectActionExecutor(this.#handlers, this.#logger);
	}
	static {
		_initClass$4();
	}
});
//#endregion
//#region src/executors/node/actions/todo_write_formatter.ts
let _initClass$3;
function _applyDecs$3(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName$3(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName$3(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey$3(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS$3(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey$3(t) {
	var i = _toPrimitive$3(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$3(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName$3(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS$3(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
const todoWriteArgsSchema = z.object({ todos: z.array(z.object({
	description: z.string(),
	status: z.enum([
		"pending",
		"in_progress",
		"completed",
		"cancelled"
	])
})) });
/**
* Formats `todo_write` tool input so the TUI can render it as a task list.
* This tool has no {@link WorkflowActionHandler}; its display mapping lives here.
*/
let _TodoWriteFormatter;
(class {
	static {
		[_TodoWriteFormatter, _initClass$3] = _applyDecs$3(this, [Injectable(ToolInputFormatter, [])], []).c;
	}
	toolName = "todo_write";
	format(args) {
		const { todos } = todoWriteArgsSchema.parse(args);
		return {
			tool: "todo_write",
			todos
		};
	}
	static {
		_initClass$3();
	}
});
//#endregion
//#region src/executors/node/actions/compaction_formatter.ts
let _initClass$2;
function _applyDecs$2(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName$2(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName$2(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey$2(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS$2(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey$2(t) {
	var i = _toPrimitive$2(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$2(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName$2(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS$2(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
/**
* Formats `compaction` tool input so the TUI can render a friendly compaction
* card. Compaction is performed by the backend; this maps the streamed args
* into a display variant. This tool has no {@link WorkflowActionHandler}; its
* display mapping lives here.
*/
let _CompactionFormatter;
(class {
	static {
		[_CompactionFormatter, _initClass$2] = _applyDecs$2(this, [Injectable(ToolInputFormatter, [])], []).c;
	}
	toolName = "compaction";
	format(args) {
		return {
			tool: "compaction",
			trigger: typeof args.trigger === "string" ? args.trigger : "",
			wasCompacted: Number(args.messages_summarized) > 0
		};
	}
	static {
		_initClass$2();
	}
});
//#endregion
//#region src/executors/node/actions/delegate_task_formatter.ts
let _initClass$1;
function _applyDecs$1(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName$1(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName$1(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey$1(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS$1(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey$1(t) {
	var i = _toPrimitive$1(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$1(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName$1(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS$1(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
const delegateTaskArgsSchema = z.object({ subagent_name: z.string().min(1).optional() });
let _DelegateTaskFormatte;
(class {
	static {
		[_DelegateTaskFormatte, _initClass$1] = _applyDecs$1(this, [Injectable(ToolInputFormatter, [])], []).c;
	}
	toolName = "delegate_task";
	format(args) {
		const parsed = delegateTaskArgsSchema.parse(args);
		return {
			tool: "delegate_task",
			...parsed.subagent_name !== void 0 ? { subagentName: parsed.subagent_name } : {}
		};
	}
	static {
		_initClass$1();
	}
});
//#endregion
//#region src/executors/node/actions/mcp_tool_formatter.ts
let _initClass;
function _applyDecs(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey(t) {
	var i = _toPrimitive(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
const mcpToolArgsSchema = z.record(z.string(), z.unknown()).optional().default({});
/**
* Formats MCP tool input. MCP tools use a namespaced name
* (`mcp__<serverName>__<toolName>`), so this formatter matches by prefix via
* {@link matches} rather than an exact `toolName`.
*/
let _McpToolFormatter;
(class {
	static {
		[_McpToolFormatter, _initClass] = _applyDecs(this, [Injectable(ToolInputFormatter, [])], []).c;
	}
	toolName = "mcp_tool";
	matches(toolName) {
		return McpToolName.is(toolName);
	}
	format(args, { toolName }) {
		const parsedArgs = mcpToolArgsSchema.parse(args);
		const { serverName, toolName: name } = McpToolName.parse(toolName);
		return {
			tool: "mcp_tool",
			serverName,
			name,
			args: parsedArgs
		};
	}
	static {
		_initClass();
	}
});
//#endregion
export { _CompactionFormatter as CompactionFormatter, _DefaultActionExecuto as DefaultActionExecutorFactory, DefaultExecutorManager, _DefaultFileStateTrac as DefaultFileStateTracker, _DefaultNodeExecutor as DefaultNodeExecutor, _DefaultNodeExecutorW as DefaultNodeExecutorWithRetry, _DefaultRgBinaryProvi as DefaultRgBinaryProvider, _DefaultRipgrepServic as DefaultRipgrepService, _DefaultWorkflowConne as DefaultWorkflowConnection, _DelegateTaskFormatte as DelegateTaskFormatter, _DesktopWorkflowRunne as DesktopWorkflowRunner, _EditFileActionHandle as EditFileActionHandler, _EditFileFormatter as EditFileFormatter, ExecutorManager, FileStateTracker, _FindFilesActionHandl as FindFilesActionHandler, _FindFilesFormatter as FindFilesFormatter, _GitlabApiRequestActi as GitlabApiRequestActionHandler, _GrepActionHandler as GrepActionHandler, _GrepFormatter as GrepFormatter, _ListDirectoryActionH as ListDirectoryActionHandler, _ListDirectoryFormatt as ListDirectoryFormatter, _MakeDirectoryActionH as MakeDirectoryActionHandler, _MakeDirectoryFormatt as MakeDirectoryFormatter, _McpToolFormatter as McpToolFormatter, NodeExecutor, NodeExecutorWithRetry, _NotifyMeWhenFormatte as NotifyMeWhenFormatter, RG_BINARY_NAME, _ReadFileActionHandle as ReadFileActionHandler, _ReadFileFormatter as ReadFileFormatter, _ReadFilesActionHandl as ReadFilesActionHandler, _ReadFilesFormatter as ReadFilesFormatter, _RunCommandActionHand as RunCommandActionHandler, _RunCommandAsProcess as RunCommandAsProcess, _RunCommandFormatter as RunCommandFormatter, _RunGitCommandActionH as RunGitCommandActionHandler, _RunGitCommandFormatt as RunGitCommandFormatter, _RunMcpToolActionHand as RunMcpToolActionHandler, _RunShellCommandActio as RunShellCommandActionHandler, _RunShellCommandForma as RunShellCommandFormatter, _ScheduleNotification as ScheduleNotificationActionHandler, _TodoWriteFormatter as TodoWriteFormatter, ToolInputFormatter, WakeScheduler, WorkflowActionHandler, WorkflowConnection, _WriteFileActionHandl as WriteFileActionHandler, _WriteFileFormatter as WriteFileFormatter, workflowExecutorContributions };

//# sourceMappingURL=node.mjs.map